import * as x from "three";
import { Controls as yt, Vector3 as S, MOUSE as W, TOUCH as Y, Quaternion as le, Spherical as ke, Vector2 as C, Ray as Tt, Plane as bt, MathUtils as Je, TrianglesDrawMode as wt, TriangleFanDrawMode as Re, TriangleStripDrawMode as et, Loader as De, LoaderUtils as q, FileLoader as fe, MeshPhysicalMaterial as H, Color as v, LinearSRGBColorSpace as z, SRGBColorSpace as F, SpotLight as xt, PointLight as Et, DirectionalLight as Mt, Matrix4 as Q, InstancedMesh as Rt, InstancedBufferAttribute as St, Object3D as tt, TextureLoader as st, ImageBitmapLoader as Lt, BufferAttribute as _e, InterleavedBuffer as It, InterleavedBufferAttribute as Pt, LinearMipmapLinearFilter as nt, NearestMipmapLinearFilter as Ct, LinearMipmapNearestFilter as Dt, NearestMipmapNearestFilter as Ot, LinearFilter as Se, NearestFilter as it, RepeatWrapping as he, MirroredRepeatWrapping as Nt, ClampToEdgeWrapping as kt, PointsMaterial as ee, Material as se, LineBasicMaterial as re, MeshStandardMaterial as ot, DoubleSide as vt, MeshBasicMaterial as te, PropertyBinding as jt, BufferGeometry as ue, SkinnedMesh as Ft, Mesh as de, LineSegments as Le, Line as Ut, LineLoop as Ht, Points as ae, Group as ce, PerspectiveCamera as Bt, OrthographicCamera as Gt, Skeleton as zt, AnimationClip as Kt, Bone as Vt, InterpolateDiscrete as Xt, InterpolateLinear as rt, Texture as ve, VectorKeyframeTrack as je, NumberKeyframeTrack as Fe, QuaternionKeyframeTrack as Ue, ColorManagement as ne, FrontSide as at, Interpolant as Yt, Box3 as Wt, Sphere as qt, Float32BufferAttribute as G, MeshPhongMaterial as ct, DefaultLoadingManager as Zt, Euler as Qt, Matrix3 as $t } from "three";
import { resolveSlots as Jt, loadImage as Ie } from "@printapp/previews-core";
const He = { type: "change" }, Oe = { type: "start" }, lt = { type: "end" }, ie = new Tt(), Be = new bt(), es = Math.cos(70 * Je.DEG2RAD), P = new S(), D = 2 * Math.PI, L = {
  NONE: -1,
  ROTATE: 0,
  DOLLY: 1,
  PAN: 2,
  TOUCH_ROTATE: 3,
  TOUCH_PAN: 4,
  TOUCH_DOLLY_PAN: 5,
  TOUCH_DOLLY_ROTATE: 6
}, Ae = 1e-6;
class ts extends yt {
  constructor(e, t = null) {
    super(e, t), this.state = L.NONE, this.enabled = !0, this.target = new S(), this.cursor = new S(), this.minDistance = 0, this.maxDistance = 1 / 0, this.minZoom = 0, this.maxZoom = 1 / 0, this.minTargetRadius = 0, this.maxTargetRadius = 1 / 0, this.minPolarAngle = 0, this.maxPolarAngle = Math.PI, this.minAzimuthAngle = -1 / 0, this.maxAzimuthAngle = 1 / 0, this.enableDamping = !1, this.dampingFactor = 0.05, this.enableZoom = !0, this.zoomSpeed = 1, this.enableRotate = !0, this.rotateSpeed = 1, this.enablePan = !0, this.panSpeed = 1, this.screenSpacePanning = !0, this.keyPanSpeed = 7, this.zoomToCursor = !1, this.autoRotate = !1, this.autoRotateSpeed = 2, this.keys = { LEFT: "ArrowLeft", UP: "ArrowUp", RIGHT: "ArrowRight", BOTTOM: "ArrowDown" }, this.mouseButtons = { LEFT: W.ROTATE, MIDDLE: W.DOLLY, RIGHT: W.PAN }, this.touches = { ONE: Y.ROTATE, TWO: Y.DOLLY_PAN }, this.target0 = this.target.clone(), this.position0 = this.object.position.clone(), this.zoom0 = this.object.zoom, this._domElementKeyEvents = null, this._lastPosition = new S(), this._lastQuaternion = new le(), this._lastTargetPosition = new S(), this._quat = new le().setFromUnitVectors(e.up, new S(0, 1, 0)), this._quatInverse = this._quat.clone().invert(), this._spherical = new ke(), this._sphericalDelta = new ke(), this._scale = 1, this._panOffset = new S(), this._rotateStart = new C(), this._rotateEnd = new C(), this._rotateDelta = new C(), this._panStart = new C(), this._panEnd = new C(), this._panDelta = new C(), this._dollyStart = new C(), this._dollyEnd = new C(), this._dollyDelta = new C(), this._dollyDirection = new S(), this._mouse = new C(), this._performCursorZoom = !1, this._pointers = [], this._pointerPositions = {}, this._controlActive = !1, this._onPointerMove = ns.bind(this), this._onPointerDown = ss.bind(this), this._onPointerUp = is.bind(this), this._onContextMenu = us.bind(this), this._onMouseWheel = as.bind(this), this._onKeyDown = cs.bind(this), this._onTouchStart = ls.bind(this), this._onTouchMove = hs.bind(this), this._onMouseDown = os.bind(this), this._onMouseMove = rs.bind(this), this._interceptControlDown = ds.bind(this), this._interceptControlUp = fs.bind(this), this.domElement !== null && this.connect(), this.update();
  }
  connect() {
    this.domElement.addEventListener("pointerdown", this._onPointerDown), this.domElement.addEventListener("pointercancel", this._onPointerUp), this.domElement.addEventListener("contextmenu", this._onContextMenu), this.domElement.addEventListener("wheel", this._onMouseWheel, { passive: !1 }), this.domElement.getRootNode().addEventListener("keydown", this._interceptControlDown, { passive: !0, capture: !0 }), this.domElement.style.touchAction = "none";
  }
  disconnect() {
    this.domElement.removeEventListener("pointerdown", this._onPointerDown), this.domElement.removeEventListener("pointermove", this._onPointerMove), this.domElement.removeEventListener("pointerup", this._onPointerUp), this.domElement.removeEventListener("pointercancel", this._onPointerUp), this.domElement.removeEventListener("wheel", this._onMouseWheel), this.domElement.removeEventListener("contextmenu", this._onContextMenu), this.stopListenToKeyEvents(), this.domElement.getRootNode().removeEventListener("keydown", this._interceptControlDown, { capture: !0 }), this.domElement.style.touchAction = "auto";
  }
  dispose() {
    this.disconnect();
  }
  getPolarAngle() {
    return this._spherical.phi;
  }
  getAzimuthalAngle() {
    return this._spherical.theta;
  }
  getDistance() {
    return this.object.position.distanceTo(this.target);
  }
  listenToKeyEvents(e) {
    e.addEventListener("keydown", this._onKeyDown), this._domElementKeyEvents = e;
  }
  stopListenToKeyEvents() {
    this._domElementKeyEvents !== null && (this._domElementKeyEvents.removeEventListener("keydown", this._onKeyDown), this._domElementKeyEvents = null);
  }
  saveState() {
    this.target0.copy(this.target), this.position0.copy(this.object.position), this.zoom0 = this.object.zoom;
  }
  reset() {
    this.target.copy(this.target0), this.object.position.copy(this.position0), this.object.zoom = this.zoom0, this.object.updateProjectionMatrix(), this.dispatchEvent(He), this.update(), this.state = L.NONE;
  }
  update(e = null) {
    const t = this.object.position;
    P.copy(t).sub(this.target), P.applyQuaternion(this._quat), this._spherical.setFromVector3(P), this.autoRotate && this.state === L.NONE && this._rotateLeft(this._getAutoRotationAngle(e)), this.enableDamping ? (this._spherical.theta += this._sphericalDelta.theta * this.dampingFactor, this._spherical.phi += this._sphericalDelta.phi * this.dampingFactor) : (this._spherical.theta += this._sphericalDelta.theta, this._spherical.phi += this._sphericalDelta.phi);
    let n = this.minAzimuthAngle, s = this.maxAzimuthAngle;
    isFinite(n) && isFinite(s) && (n < -Math.PI ? n += D : n > Math.PI && (n -= D), s < -Math.PI ? s += D : s > Math.PI && (s -= D), n <= s ? this._spherical.theta = Math.max(n, Math.min(s, this._spherical.theta)) : this._spherical.theta = this._spherical.theta > (n + s) / 2 ? Math.max(n, this._spherical.theta) : Math.min(s, this._spherical.theta)), this._spherical.phi = Math.max(this.minPolarAngle, Math.min(this.maxPolarAngle, this._spherical.phi)), this._spherical.makeSafe(), this.enableDamping === !0 ? this.target.addScaledVector(this._panOffset, this.dampingFactor) : this.target.add(this._panOffset), this.target.sub(this.cursor), this.target.clampLength(this.minTargetRadius, this.maxTargetRadius), this.target.add(this.cursor);
    let i = !1;
    if (this.zoomToCursor && this._performCursorZoom || this.object.isOrthographicCamera)
      this._spherical.radius = this._clampDistance(this._spherical.radius);
    else {
      const o = this._spherical.radius;
      this._spherical.radius = this._clampDistance(this._spherical.radius * this._scale), i = o != this._spherical.radius;
    }
    if (P.setFromSpherical(this._spherical), P.applyQuaternion(this._quatInverse), t.copy(this.target).add(P), this.object.lookAt(this.target), this.enableDamping === !0 ? (this._sphericalDelta.theta *= 1 - this.dampingFactor, this._sphericalDelta.phi *= 1 - this.dampingFactor, this._panOffset.multiplyScalar(1 - this.dampingFactor)) : (this._sphericalDelta.set(0, 0, 0), this._panOffset.set(0, 0, 0)), this.zoomToCursor && this._performCursorZoom) {
      let o = null;
      if (this.object.isPerspectiveCamera) {
        const c = P.length();
        o = this._clampDistance(c * this._scale);
        const a = c - o;
        this.object.position.addScaledVector(this._dollyDirection, a), this.object.updateMatrixWorld(), i = !!a;
      } else if (this.object.isOrthographicCamera) {
        const c = new S(this._mouse.x, this._mouse.y, 0);
        c.unproject(this.object);
        const a = this.object.zoom;
        this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale)), this.object.updateProjectionMatrix(), i = a !== this.object.zoom;
        const l = new S(this._mouse.x, this._mouse.y, 0);
        l.unproject(this.object), this.object.position.sub(l).add(c), this.object.updateMatrixWorld(), o = P.length();
      } else
        console.warn("WARNING: OrbitControls.js encountered an unknown camera type - zoom to cursor disabled."), this.zoomToCursor = !1;
      o !== null && (this.screenSpacePanning ? this.target.set(0, 0, -1).transformDirection(this.object.matrix).multiplyScalar(o).add(this.object.position) : (ie.origin.copy(this.object.position), ie.direction.set(0, 0, -1).transformDirection(this.object.matrix), Math.abs(this.object.up.dot(ie.direction)) < es ? this.object.lookAt(this.target) : (Be.setFromNormalAndCoplanarPoint(this.object.up, this.target), ie.intersectPlane(Be, this.target))));
    } else if (this.object.isOrthographicCamera) {
      const o = this.object.zoom;
      this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom / this._scale)), o !== this.object.zoom && (this.object.updateProjectionMatrix(), i = !0);
    }
    return this._scale = 1, this._performCursorZoom = !1, i || this._lastPosition.distanceToSquared(this.object.position) > Ae || 8 * (1 - this._lastQuaternion.dot(this.object.quaternion)) > Ae || this._lastTargetPosition.distanceToSquared(this.target) > Ae ? (this.dispatchEvent(He), this._lastPosition.copy(this.object.position), this._lastQuaternion.copy(this.object.quaternion), this._lastTargetPosition.copy(this.target), !0) : !1;
  }
  _getAutoRotationAngle(e) {
    return e !== null ? D / 60 * this.autoRotateSpeed * e : D / 60 / 60 * this.autoRotateSpeed;
  }
  _getZoomScale(e) {
    const t = Math.abs(e * 0.01);
    return Math.pow(0.95, this.zoomSpeed * t);
  }
  _rotateLeft(e) {
    this._sphericalDelta.theta -= e;
  }
  _rotateUp(e) {
    this._sphericalDelta.phi -= e;
  }
  _panLeft(e, t) {
    P.setFromMatrixColumn(t, 0), P.multiplyScalar(-e), this._panOffset.add(P);
  }
  _panUp(e, t) {
    this.screenSpacePanning === !0 ? P.setFromMatrixColumn(t, 1) : (P.setFromMatrixColumn(t, 0), P.crossVectors(this.object.up, P)), P.multiplyScalar(e), this._panOffset.add(P);
  }
  // deltaX and deltaY are in pixels; right and down are positive
  _pan(e, t) {
    const n = this.domElement;
    if (this.object.isPerspectiveCamera) {
      const s = this.object.position;
      P.copy(s).sub(this.target);
      let i = P.length();
      i *= Math.tan(this.object.fov / 2 * Math.PI / 180), this._panLeft(2 * e * i / n.clientHeight, this.object.matrix), this._panUp(2 * t * i / n.clientHeight, this.object.matrix);
    } else this.object.isOrthographicCamera ? (this._panLeft(e * (this.object.right - this.object.left) / this.object.zoom / n.clientWidth, this.object.matrix), this._panUp(t * (this.object.top - this.object.bottom) / this.object.zoom / n.clientHeight, this.object.matrix)) : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - pan disabled."), this.enablePan = !1);
  }
  _dollyOut(e) {
    this.object.isPerspectiveCamera || this.object.isOrthographicCamera ? this._scale /= e : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."), this.enableZoom = !1);
  }
  _dollyIn(e) {
    this.object.isPerspectiveCamera || this.object.isOrthographicCamera ? this._scale *= e : (console.warn("WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled."), this.enableZoom = !1);
  }
  _updateZoomParameters(e, t) {
    if (!this.zoomToCursor)
      return;
    this._performCursorZoom = !0;
    const n = this.domElement.getBoundingClientRect(), s = e - n.left, i = t - n.top, o = n.width, c = n.height;
    this._mouse.x = s / o * 2 - 1, this._mouse.y = -(i / c) * 2 + 1, this._dollyDirection.set(this._mouse.x, this._mouse.y, 1).unproject(this.object).sub(this.object.position).normalize();
  }
  _clampDistance(e) {
    return Math.max(this.minDistance, Math.min(this.maxDistance, e));
  }
  //
  // event callbacks - update the object state
  //
  _handleMouseDownRotate(e) {
    this._rotateStart.set(e.clientX, e.clientY);
  }
  _handleMouseDownDolly(e) {
    this._updateZoomParameters(e.clientX, e.clientX), this._dollyStart.set(e.clientX, e.clientY);
  }
  _handleMouseDownPan(e) {
    this._panStart.set(e.clientX, e.clientY);
  }
  _handleMouseMoveRotate(e) {
    this._rotateEnd.set(e.clientX, e.clientY), this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
    const t = this.domElement;
    this._rotateLeft(D * this._rotateDelta.x / t.clientHeight), this._rotateUp(D * this._rotateDelta.y / t.clientHeight), this._rotateStart.copy(this._rotateEnd), this.update();
  }
  _handleMouseMoveDolly(e) {
    this._dollyEnd.set(e.clientX, e.clientY), this._dollyDelta.subVectors(this._dollyEnd, this._dollyStart), this._dollyDelta.y > 0 ? this._dollyOut(this._getZoomScale(this._dollyDelta.y)) : this._dollyDelta.y < 0 && this._dollyIn(this._getZoomScale(this._dollyDelta.y)), this._dollyStart.copy(this._dollyEnd), this.update();
  }
  _handleMouseMovePan(e) {
    this._panEnd.set(e.clientX, e.clientY), this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed), this._pan(this._panDelta.x, this._panDelta.y), this._panStart.copy(this._panEnd), this.update();
  }
  _handleMouseWheel(e) {
    this._updateZoomParameters(e.clientX, e.clientY), e.deltaY < 0 ? this._dollyIn(this._getZoomScale(e.deltaY)) : e.deltaY > 0 && this._dollyOut(this._getZoomScale(e.deltaY)), this.update();
  }
  _handleKeyDown(e) {
    let t = !1;
    switch (e.code) {
      case this.keys.UP:
        e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateUp(D * this.rotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(0, this.keyPanSpeed), t = !0;
        break;
      case this.keys.BOTTOM:
        e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateUp(-D * this.rotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(0, -this.keyPanSpeed), t = !0;
        break;
      case this.keys.LEFT:
        e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateLeft(D * this.rotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(this.keyPanSpeed, 0), t = !0;
        break;
      case this.keys.RIGHT:
        e.ctrlKey || e.metaKey || e.shiftKey ? this.enableRotate && this._rotateLeft(-D * this.rotateSpeed / this.domElement.clientHeight) : this.enablePan && this._pan(-this.keyPanSpeed, 0), t = !0;
        break;
    }
    t && (e.preventDefault(), this.update());
  }
  _handleTouchStartRotate(e) {
    if (this._pointers.length === 1)
      this._rotateStart.set(e.pageX, e.pageY);
    else {
      const t = this._getSecondPointerPosition(e), n = 0.5 * (e.pageX + t.x), s = 0.5 * (e.pageY + t.y);
      this._rotateStart.set(n, s);
    }
  }
  _handleTouchStartPan(e) {
    if (this._pointers.length === 1)
      this._panStart.set(e.pageX, e.pageY);
    else {
      const t = this._getSecondPointerPosition(e), n = 0.5 * (e.pageX + t.x), s = 0.5 * (e.pageY + t.y);
      this._panStart.set(n, s);
    }
  }
  _handleTouchStartDolly(e) {
    const t = this._getSecondPointerPosition(e), n = e.pageX - t.x, s = e.pageY - t.y, i = Math.sqrt(n * n + s * s);
    this._dollyStart.set(0, i);
  }
  _handleTouchStartDollyPan(e) {
    this.enableZoom && this._handleTouchStartDolly(e), this.enablePan && this._handleTouchStartPan(e);
  }
  _handleTouchStartDollyRotate(e) {
    this.enableZoom && this._handleTouchStartDolly(e), this.enableRotate && this._handleTouchStartRotate(e);
  }
  _handleTouchMoveRotate(e) {
    if (this._pointers.length == 1)
      this._rotateEnd.set(e.pageX, e.pageY);
    else {
      const n = this._getSecondPointerPosition(e), s = 0.5 * (e.pageX + n.x), i = 0.5 * (e.pageY + n.y);
      this._rotateEnd.set(s, i);
    }
    this._rotateDelta.subVectors(this._rotateEnd, this._rotateStart).multiplyScalar(this.rotateSpeed);
    const t = this.domElement;
    this._rotateLeft(D * this._rotateDelta.x / t.clientHeight), this._rotateUp(D * this._rotateDelta.y / t.clientHeight), this._rotateStart.copy(this._rotateEnd);
  }
  _handleTouchMovePan(e) {
    if (this._pointers.length === 1)
      this._panEnd.set(e.pageX, e.pageY);
    else {
      const t = this._getSecondPointerPosition(e), n = 0.5 * (e.pageX + t.x), s = 0.5 * (e.pageY + t.y);
      this._panEnd.set(n, s);
    }
    this._panDelta.subVectors(this._panEnd, this._panStart).multiplyScalar(this.panSpeed), this._pan(this._panDelta.x, this._panDelta.y), this._panStart.copy(this._panEnd);
  }
  _handleTouchMoveDolly(e) {
    const t = this._getSecondPointerPosition(e), n = e.pageX - t.x, s = e.pageY - t.y, i = Math.sqrt(n * n + s * s);
    this._dollyEnd.set(0, i), this._dollyDelta.set(0, Math.pow(this._dollyEnd.y / this._dollyStart.y, this.zoomSpeed)), this._dollyOut(this._dollyDelta.y), this._dollyStart.copy(this._dollyEnd);
    const o = (e.pageX + t.x) * 0.5, c = (e.pageY + t.y) * 0.5;
    this._updateZoomParameters(o, c);
  }
  _handleTouchMoveDollyPan(e) {
    this.enableZoom && this._handleTouchMoveDolly(e), this.enablePan && this._handleTouchMovePan(e);
  }
  _handleTouchMoveDollyRotate(e) {
    this.enableZoom && this._handleTouchMoveDolly(e), this.enableRotate && this._handleTouchMoveRotate(e);
  }
  // pointers
  _addPointer(e) {
    this._pointers.push(e.pointerId);
  }
  _removePointer(e) {
    delete this._pointerPositions[e.pointerId];
    for (let t = 0; t < this._pointers.length; t++)
      if (this._pointers[t] == e.pointerId) {
        this._pointers.splice(t, 1);
        return;
      }
  }
  _isTrackingPointer(e) {
    for (let t = 0; t < this._pointers.length; t++)
      if (this._pointers[t] == e.pointerId) return !0;
    return !1;
  }
  _trackPointer(e) {
    let t = this._pointerPositions[e.pointerId];
    t === void 0 && (t = new C(), this._pointerPositions[e.pointerId] = t), t.set(e.pageX, e.pageY);
  }
  _getSecondPointerPosition(e) {
    const t = e.pointerId === this._pointers[0] ? this._pointers[1] : this._pointers[0];
    return this._pointerPositions[t];
  }
  //
  _customWheelEvent(e) {
    const t = e.deltaMode, n = {
      clientX: e.clientX,
      clientY: e.clientY,
      deltaY: e.deltaY
    };
    switch (t) {
      case 1:
        n.deltaY *= 16;
        break;
      case 2:
        n.deltaY *= 100;
        break;
    }
    return e.ctrlKey && !this._controlActive && (n.deltaY *= 10), n;
  }
}
function ss(r) {
  this.enabled !== !1 && (this._pointers.length === 0 && (this.domElement.setPointerCapture(r.pointerId), this.domElement.addEventListener("pointermove", this._onPointerMove), this.domElement.addEventListener("pointerup", this._onPointerUp)), !this._isTrackingPointer(r) && (this._addPointer(r), r.pointerType === "touch" ? this._onTouchStart(r) : this._onMouseDown(r)));
}
function ns(r) {
  this.enabled !== !1 && (r.pointerType === "touch" ? this._onTouchMove(r) : this._onMouseMove(r));
}
function is(r) {
  switch (this._removePointer(r), this._pointers.length) {
    case 0:
      this.domElement.releasePointerCapture(r.pointerId), this.domElement.removeEventListener("pointermove", this._onPointerMove), this.domElement.removeEventListener("pointerup", this._onPointerUp), this.dispatchEvent(lt), this.state = L.NONE;
      break;
    case 1:
      const e = this._pointers[0], t = this._pointerPositions[e];
      this._onTouchStart({ pointerId: e, pageX: t.x, pageY: t.y });
      break;
  }
}
function os(r) {
  let e;
  switch (r.button) {
    case 0:
      e = this.mouseButtons.LEFT;
      break;
    case 1:
      e = this.mouseButtons.MIDDLE;
      break;
    case 2:
      e = this.mouseButtons.RIGHT;
      break;
    default:
      e = -1;
  }
  switch (e) {
    case W.DOLLY:
      if (this.enableZoom === !1) return;
      this._handleMouseDownDolly(r), this.state = L.DOLLY;
      break;
    case W.ROTATE:
      if (r.ctrlKey || r.metaKey || r.shiftKey) {
        if (this.enablePan === !1) return;
        this._handleMouseDownPan(r), this.state = L.PAN;
      } else {
        if (this.enableRotate === !1) return;
        this._handleMouseDownRotate(r), this.state = L.ROTATE;
      }
      break;
    case W.PAN:
      if (r.ctrlKey || r.metaKey || r.shiftKey) {
        if (this.enableRotate === !1) return;
        this._handleMouseDownRotate(r), this.state = L.ROTATE;
      } else {
        if (this.enablePan === !1) return;
        this._handleMouseDownPan(r), this.state = L.PAN;
      }
      break;
    default:
      this.state = L.NONE;
  }
  this.state !== L.NONE && this.dispatchEvent(Oe);
}
function rs(r) {
  switch (this.state) {
    case L.ROTATE:
      if (this.enableRotate === !1) return;
      this._handleMouseMoveRotate(r);
      break;
    case L.DOLLY:
      if (this.enableZoom === !1) return;
      this._handleMouseMoveDolly(r);
      break;
    case L.PAN:
      if (this.enablePan === !1) return;
      this._handleMouseMovePan(r);
      break;
  }
}
function as(r) {
  this.enabled === !1 || this.enableZoom === !1 || this.state !== L.NONE || (r.preventDefault(), this.dispatchEvent(Oe), this._handleMouseWheel(this._customWheelEvent(r)), this.dispatchEvent(lt));
}
function cs(r) {
  this.enabled !== !1 && this._handleKeyDown(r);
}
function ls(r) {
  switch (this._trackPointer(r), this._pointers.length) {
    case 1:
      switch (this.touches.ONE) {
        case Y.ROTATE:
          if (this.enableRotate === !1) return;
          this._handleTouchStartRotate(r), this.state = L.TOUCH_ROTATE;
          break;
        case Y.PAN:
          if (this.enablePan === !1) return;
          this._handleTouchStartPan(r), this.state = L.TOUCH_PAN;
          break;
        default:
          this.state = L.NONE;
      }
      break;
    case 2:
      switch (this.touches.TWO) {
        case Y.DOLLY_PAN:
          if (this.enableZoom === !1 && this.enablePan === !1) return;
          this._handleTouchStartDollyPan(r), this.state = L.TOUCH_DOLLY_PAN;
          break;
        case Y.DOLLY_ROTATE:
          if (this.enableZoom === !1 && this.enableRotate === !1) return;
          this._handleTouchStartDollyRotate(r), this.state = L.TOUCH_DOLLY_ROTATE;
          break;
        default:
          this.state = L.NONE;
      }
      break;
    default:
      this.state = L.NONE;
  }
  this.state !== L.NONE && this.dispatchEvent(Oe);
}
function hs(r) {
  switch (this._trackPointer(r), this.state) {
    case L.TOUCH_ROTATE:
      if (this.enableRotate === !1) return;
      this._handleTouchMoveRotate(r), this.update();
      break;
    case L.TOUCH_PAN:
      if (this.enablePan === !1) return;
      this._handleTouchMovePan(r), this.update();
      break;
    case L.TOUCH_DOLLY_PAN:
      if (this.enableZoom === !1 && this.enablePan === !1) return;
      this._handleTouchMoveDollyPan(r), this.update();
      break;
    case L.TOUCH_DOLLY_ROTATE:
      if (this.enableZoom === !1 && this.enableRotate === !1) return;
      this._handleTouchMoveDollyRotate(r), this.update();
      break;
    default:
      this.state = L.NONE;
  }
}
function us(r) {
  this.enabled !== !1 && r.preventDefault();
}
function ds(r) {
  r.key === "Control" && (this._controlActive = !0, this.domElement.getRootNode().addEventListener("keyup", this._interceptControlUp, { passive: !0, capture: !0 }));
}
function fs(r) {
  r.key === "Control" && (this._controlActive = !1, this.domElement.getRootNode().removeEventListener("keyup", this._interceptControlUp, { passive: !0, capture: !0 }));
}
class ps {
  scene = new x.Scene();
  camera;
  renderer;
  controls;
  /** Container group for the active model; cleared/replaced on model change. */
  modelRoot = new x.Group();
  animationId;
  container;
  onInteract;
  constructor(e, t) {
    this.container = e, this.renderer = new x.WebGLRenderer({ antialias: !0, alpha: !0 }), this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2)), this.renderer.outputColorSpace = x.SRGBColorSpace, this.renderer.toneMapping = x.ACESFilmicToneMapping, this.renderer.domElement.style.display = "block", this.renderer.domElement.style.width = "100%", this.renderer.domElement.style.height = "100%", e.append(this.renderer.domElement);
    const { clientWidth: n, clientHeight: s } = e;
    this.camera = new x.PerspectiveCamera(
      t.camera.fov,
      n / Math.max(s, 1),
      0.01,
      1e3
    ), this.camera.position.set(...t.camera.position), this.controls = new ts(this.camera, this.renderer.domElement), this.controls.enableDamping = !0, this.controls.dampingFactor = 0.08, this.controls.minDistance = t.camera.minDistance, this.controls.maxDistance = t.camera.maxDistance, this.controls.autoRotate = t.camera.autoRotate, this.controls.target.set(...t.camera.target), this.controls.addEventListener("change", () => this.onInteract?.()), t.background.color !== "transparent" && (this.scene.background = new x.Color(t.background.color)), this.scene.add(this.modelRoot), this.scene.add(this.camera), this.resize();
  }
  /** Register a callback fired whenever the user moves the camera. */
  setInteractionHandler(e) {
    this.onInteract = e;
  }
  /** Start the render loop. */
  start() {
    const e = () => {
      this.animationId = requestAnimationFrame(e), this.controls.update(), this.renderer.render(this.scene, this.camera);
    };
    e();
  }
  /** Frame the camera so a sphere of `radius` at the origin fits the view. */
  frame(e, t) {
    const n = this.camera.position.clone().normalize();
    n.lengthSq() === 0 && n.set(0, 0, 1), this.camera.position.copy(n.multiplyScalar(t)), this.controls.target.set(0, 0, 0), this.camera.near = Math.max(e / 100, 0.01), this.camera.far = t + e * 10, this.camera.updateProjectionMatrix(), this.controls.update();
  }
  resize() {
    const e = this.container.clientWidth, t = this.container.clientHeight;
    e === 0 || t === 0 || (this.renderer.setSize(e, t, !1), this.renderer.domElement.style.width = "100%", this.renderer.domElement.style.height = "100%", this.camera.aspect = e / t, this.camera.updateProjectionMatrix());
  }
  /** Convert a pointer event to normalized device coordinates for raycasting. */
  toNdc(e) {
    const t = this.renderer.domElement.getBoundingClientRect();
    return new x.Vector2(
      (e.clientX - t.left) / t.width * 2 - 1,
      -((e.clientY - t.top) / t.height) * 2 + 1
    );
  }
  dispose() {
    this.animationId !== void 0 && cancelAnimationFrame(this.animationId), this.controls.dispose(), this.renderer.dispose(), this.renderer.domElement.remove(), this.scene.traverse((e) => {
      const t = e;
      if (t.isMesh) {
        t.geometry?.dispose();
        const n = Array.isArray(t.material) ? t.material : [t.material];
        for (const s of n) s?.dispose();
      }
    });
  }
}
function ms(r, e) {
  const t = new x.Group();
  t.name = "pa-lights";
  for (const n of r) {
    const s = _s(n);
    s && (n.followCamera && e && (n.type === "directional" || n.type === "point") ? gs(s, e) : t.add(s));
  }
  return t;
}
function gs(r, e) {
  e.add(r);
  const t = r;
  t.isDirectionalLight && (t.target.position.set(0, 0, -1), e.add(t.target));
}
function _s(r) {
  const e = new x.Color(r.color);
  switch (r.type) {
    case "ambient":
      return new x.AmbientLight(e, r.intensity);
    case "hemisphere": {
      const t = new x.HemisphereLight(e, new x.Color("#444444"), r.intensity);
      return ye(t, r.position), t;
    }
    case "directional": {
      const t = new x.DirectionalLight(e, r.intensity);
      return ye(t, r.position ?? [5, 10, 7]), t;
    }
    case "point": {
      const t = new x.PointLight(e, r.intensity);
      return ye(t, r.position ?? [5, 5, 5]), t;
    }
    default:
      return;
  }
}
function ye(r, e) {
  e && r.position.set(e[0], e[1], e[2]);
}
function Ge(r, e) {
  if (e === wt)
    return console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles."), r;
  if (e === Re || e === et) {
    let t = r.getIndex();
    if (t === null) {
      const o = [], c = r.getAttribute("position");
      if (c !== void 0) {
        for (let a = 0; a < c.count; a++)
          o.push(a);
        r.setIndex(o), t = r.getIndex();
      } else
        return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible."), r;
    }
    const n = t.count - 2, s = [];
    if (e === Re)
      for (let o = 1; o <= n; o++)
        s.push(t.getX(0)), s.push(t.getX(o)), s.push(t.getX(o + 1));
    else
      for (let o = 0; o < n; o++)
        o % 2 === 0 ? (s.push(t.getX(o)), s.push(t.getX(o + 1)), s.push(t.getX(o + 2))) : (s.push(t.getX(o + 2)), s.push(t.getX(o + 1)), s.push(t.getX(o)));
    s.length / 3 !== n && console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
    const i = r.clone();
    return i.setIndex(s), i.clearGroups(), i;
  } else
    return console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", e), r;
}
class As extends De {
  constructor(e) {
    super(e), this.dracoLoader = null, this.ktx2Loader = null, this.meshoptDecoder = null, this.pluginCallbacks = [], this.register(function(t) {
      return new xs(t);
    }), this.register(function(t) {
      return new Es(t);
    }), this.register(function(t) {
      return new Os(t);
    }), this.register(function(t) {
      return new Ns(t);
    }), this.register(function(t) {
      return new ks(t);
    }), this.register(function(t) {
      return new Rs(t);
    }), this.register(function(t) {
      return new Ss(t);
    }), this.register(function(t) {
      return new Ls(t);
    }), this.register(function(t) {
      return new Is(t);
    }), this.register(function(t) {
      return new ws(t);
    }), this.register(function(t) {
      return new Ps(t);
    }), this.register(function(t) {
      return new Ms(t);
    }), this.register(function(t) {
      return new Ds(t);
    }), this.register(function(t) {
      return new Cs(t);
    }), this.register(function(t) {
      return new Ts(t);
    }), this.register(function(t) {
      return new vs(t);
    }), this.register(function(t) {
      return new js(t);
    });
  }
  load(e, t, n, s) {
    const i = this;
    let o;
    if (this.resourcePath !== "")
      o = this.resourcePath;
    else if (this.path !== "") {
      const l = q.extractUrlBase(e);
      o = q.resolveURL(l, this.path);
    } else
      o = q.extractUrlBase(e);
    this.manager.itemStart(e);
    const c = function(l) {
      s ? s(l) : console.error(l), i.manager.itemError(e), i.manager.itemEnd(e);
    }, a = new fe(this.manager);
    a.setPath(this.path), a.setResponseType("arraybuffer"), a.setRequestHeader(this.requestHeader), a.setWithCredentials(this.withCredentials), a.load(e, function(l) {
      try {
        i.parse(l, o, function(u) {
          t(u), i.manager.itemEnd(e);
        }, c);
      } catch (u) {
        c(u);
      }
    }, n, c);
  }
  setDRACOLoader(e) {
    return this.dracoLoader = e, this;
  }
  setKTX2Loader(e) {
    return this.ktx2Loader = e, this;
  }
  setMeshoptDecoder(e) {
    return this.meshoptDecoder = e, this;
  }
  register(e) {
    return this.pluginCallbacks.indexOf(e) === -1 && this.pluginCallbacks.push(e), this;
  }
  unregister(e) {
    return this.pluginCallbacks.indexOf(e) !== -1 && this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(e), 1), this;
  }
  parse(e, t, n, s) {
    let i;
    const o = {}, c = {}, a = new TextDecoder();
    if (typeof e == "string")
      i = JSON.parse(e);
    else if (e instanceof ArrayBuffer)
      if (a.decode(new Uint8Array(e, 0, 4)) === ht) {
        try {
          o[E.KHR_BINARY_GLTF] = new Fs(e);
        } catch (h) {
          s && s(h);
          return;
        }
        i = JSON.parse(o[E.KHR_BINARY_GLTF].content);
      } else
        i = JSON.parse(a.decode(e));
    else
      i = e;
    if (i.asset === void 0 || i.asset.version[0] < 2) {
      s && s(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
      return;
    }
    const l = new Qs(i, {
      path: t || this.resourcePath || "",
      crossOrigin: this.crossOrigin,
      requestHeader: this.requestHeader,
      manager: this.manager,
      ktx2Loader: this.ktx2Loader,
      meshoptDecoder: this.meshoptDecoder
    });
    l.fileLoader.setRequestHeader(this.requestHeader);
    for (let u = 0; u < this.pluginCallbacks.length; u++) {
      const h = this.pluginCallbacks[u](l);
      h.name || console.error("THREE.GLTFLoader: Invalid plugin found: missing name"), c[h.name] = h, o[h.name] = !0;
    }
    if (i.extensionsUsed)
      for (let u = 0; u < i.extensionsUsed.length; ++u) {
        const h = i.extensionsUsed[u], d = i.extensionsRequired || [];
        switch (h) {
          case E.KHR_MATERIALS_UNLIT:
            o[h] = new bs();
            break;
          case E.KHR_DRACO_MESH_COMPRESSION:
            o[h] = new Us(i, this.dracoLoader);
            break;
          case E.KHR_TEXTURE_TRANSFORM:
            o[h] = new Hs();
            break;
          case E.KHR_MESH_QUANTIZATION:
            o[h] = new Bs();
            break;
          default:
            d.indexOf(h) >= 0 && c[h] === void 0 && console.warn('THREE.GLTFLoader: Unknown extension "' + h + '".');
        }
      }
    l.setExtensions(o), l.setPlugins(c), l.parse(n, s);
  }
  parseAsync(e, t) {
    const n = this;
    return new Promise(function(s, i) {
      n.parse(e, t, s, i);
    });
  }
}
function ys() {
  let r = {};
  return {
    get: function(e) {
      return r[e];
    },
    add: function(e, t) {
      r[e] = t;
    },
    remove: function(e) {
      delete r[e];
    },
    removeAll: function() {
      r = {};
    }
  };
}
const E = {
  KHR_BINARY_GLTF: "KHR_binary_glTF",
  KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
  KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
  KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
  KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
  KHR_MATERIALS_IOR: "KHR_materials_ior",
  KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
  KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
  KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
  KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
  KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
  KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
  KHR_MATERIALS_VOLUME: "KHR_materials_volume",
  KHR_TEXTURE_BASISU: "KHR_texture_basisu",
  KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
  KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
  KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
  EXT_MATERIALS_BUMP: "EXT_materials_bump",
  EXT_TEXTURE_WEBP: "EXT_texture_webp",
  EXT_TEXTURE_AVIF: "EXT_texture_avif",
  EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
  EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class Ts {
  constructor(e) {
    this.parser = e, this.name = E.KHR_LIGHTS_PUNCTUAL, this.cache = { refs: {}, uses: {} };
  }
  _markDefs() {
    const e = this.parser, t = this.parser.json.nodes || [];
    for (let n = 0, s = t.length; n < s; n++) {
      const i = t[n];
      i.extensions && i.extensions[this.name] && i.extensions[this.name].light !== void 0 && e._addNodeRef(this.cache, i.extensions[this.name].light);
    }
  }
  _loadLight(e) {
    const t = this.parser, n = "light:" + e;
    let s = t.cache.get(n);
    if (s) return s;
    const i = t.json, a = ((i.extensions && i.extensions[this.name] || {}).lights || [])[e];
    let l;
    const u = new v(16777215);
    a.color !== void 0 && u.setRGB(a.color[0], a.color[1], a.color[2], z);
    const h = a.range !== void 0 ? a.range : 0;
    switch (a.type) {
      case "directional":
        l = new Mt(u), l.target.position.set(0, 0, -1), l.add(l.target);
        break;
      case "point":
        l = new Et(u), l.distance = h;
        break;
      case "spot":
        l = new xt(u), l.distance = h, a.spot = a.spot || {}, a.spot.innerConeAngle = a.spot.innerConeAngle !== void 0 ? a.spot.innerConeAngle : 0, a.spot.outerConeAngle = a.spot.outerConeAngle !== void 0 ? a.spot.outerConeAngle : Math.PI / 4, l.angle = a.spot.outerConeAngle, l.penumbra = 1 - a.spot.innerConeAngle / a.spot.outerConeAngle, l.target.position.set(0, 0, -1), l.add(l.target);
        break;
      default:
        throw new Error("THREE.GLTFLoader: Unexpected light type: " + a.type);
    }
    return l.position.set(0, 0, 0), l.decay = 2, B(l, a), a.intensity !== void 0 && (l.intensity = a.intensity), l.name = t.createUniqueName(a.name || "light_" + e), s = Promise.resolve(l), t.cache.add(n, s), s;
  }
  getDependency(e, t) {
    if (e === "light")
      return this._loadLight(t);
  }
  createNodeAttachment(e) {
    const t = this, n = this.parser, i = n.json.nodes[e], c = (i.extensions && i.extensions[this.name] || {}).light;
    return c === void 0 ? null : this._loadLight(c).then(function(a) {
      return n._getNodeRef(t.cache, c, a);
    });
  }
}
class bs {
  constructor() {
    this.name = E.KHR_MATERIALS_UNLIT;
  }
  getMaterialType() {
    return te;
  }
  extendParams(e, t, n) {
    const s = [];
    e.color = new v(1, 1, 1), e.opacity = 1;
    const i = t.pbrMetallicRoughness;
    if (i) {
      if (Array.isArray(i.baseColorFactor)) {
        const o = i.baseColorFactor;
        e.color.setRGB(o[0], o[1], o[2], z), e.opacity = o[3];
      }
      i.baseColorTexture !== void 0 && s.push(n.assignTexture(e, "map", i.baseColorTexture, F));
    }
    return Promise.all(s);
  }
}
class ws {
  constructor(e) {
    this.parser = e, this.name = E.KHR_MATERIALS_EMISSIVE_STRENGTH;
  }
  extendMaterialParams(e, t) {
    const s = this.parser.json.materials[e];
    if (!s.extensions || !s.extensions[this.name])
      return Promise.resolve();
    const i = s.extensions[this.name].emissiveStrength;
    return i !== void 0 && (t.emissiveIntensity = i), Promise.resolve();
  }
}
class xs {
  constructor(e) {
    this.parser = e, this.name = E.KHR_MATERIALS_CLEARCOAT;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : H;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, s = n.json.materials[e];
    if (!s.extensions || !s.extensions[this.name])
      return Promise.resolve();
    const i = [], o = s.extensions[this.name];
    if (o.clearcoatFactor !== void 0 && (t.clearcoat = o.clearcoatFactor), o.clearcoatTexture !== void 0 && i.push(n.assignTexture(t, "clearcoatMap", o.clearcoatTexture)), o.clearcoatRoughnessFactor !== void 0 && (t.clearcoatRoughness = o.clearcoatRoughnessFactor), o.clearcoatRoughnessTexture !== void 0 && i.push(n.assignTexture(t, "clearcoatRoughnessMap", o.clearcoatRoughnessTexture)), o.clearcoatNormalTexture !== void 0 && (i.push(n.assignTexture(t, "clearcoatNormalMap", o.clearcoatNormalTexture)), o.clearcoatNormalTexture.scale !== void 0)) {
      const c = o.clearcoatNormalTexture.scale;
      t.clearcoatNormalScale = new C(c, c);
    }
    return Promise.all(i);
  }
}
class Es {
  constructor(e) {
    this.parser = e, this.name = E.KHR_MATERIALS_DISPERSION;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : H;
  }
  extendMaterialParams(e, t) {
    const s = this.parser.json.materials[e];
    if (!s.extensions || !s.extensions[this.name])
      return Promise.resolve();
    const i = s.extensions[this.name];
    return t.dispersion = i.dispersion !== void 0 ? i.dispersion : 0, Promise.resolve();
  }
}
class Ms {
  constructor(e) {
    this.parser = e, this.name = E.KHR_MATERIALS_IRIDESCENCE;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : H;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, s = n.json.materials[e];
    if (!s.extensions || !s.extensions[this.name])
      return Promise.resolve();
    const i = [], o = s.extensions[this.name];
    return o.iridescenceFactor !== void 0 && (t.iridescence = o.iridescenceFactor), o.iridescenceTexture !== void 0 && i.push(n.assignTexture(t, "iridescenceMap", o.iridescenceTexture)), o.iridescenceIor !== void 0 && (t.iridescenceIOR = o.iridescenceIor), t.iridescenceThicknessRange === void 0 && (t.iridescenceThicknessRange = [100, 400]), o.iridescenceThicknessMinimum !== void 0 && (t.iridescenceThicknessRange[0] = o.iridescenceThicknessMinimum), o.iridescenceThicknessMaximum !== void 0 && (t.iridescenceThicknessRange[1] = o.iridescenceThicknessMaximum), o.iridescenceThicknessTexture !== void 0 && i.push(n.assignTexture(t, "iridescenceThicknessMap", o.iridescenceThicknessTexture)), Promise.all(i);
  }
}
class Rs {
  constructor(e) {
    this.parser = e, this.name = E.KHR_MATERIALS_SHEEN;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : H;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, s = n.json.materials[e];
    if (!s.extensions || !s.extensions[this.name])
      return Promise.resolve();
    const i = [];
    t.sheenColor = new v(0, 0, 0), t.sheenRoughness = 0, t.sheen = 1;
    const o = s.extensions[this.name];
    if (o.sheenColorFactor !== void 0) {
      const c = o.sheenColorFactor;
      t.sheenColor.setRGB(c[0], c[1], c[2], z);
    }
    return o.sheenRoughnessFactor !== void 0 && (t.sheenRoughness = o.sheenRoughnessFactor), o.sheenColorTexture !== void 0 && i.push(n.assignTexture(t, "sheenColorMap", o.sheenColorTexture, F)), o.sheenRoughnessTexture !== void 0 && i.push(n.assignTexture(t, "sheenRoughnessMap", o.sheenRoughnessTexture)), Promise.all(i);
  }
}
class Ss {
  constructor(e) {
    this.parser = e, this.name = E.KHR_MATERIALS_TRANSMISSION;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : H;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, s = n.json.materials[e];
    if (!s.extensions || !s.extensions[this.name])
      return Promise.resolve();
    const i = [], o = s.extensions[this.name];
    return o.transmissionFactor !== void 0 && (t.transmission = o.transmissionFactor), o.transmissionTexture !== void 0 && i.push(n.assignTexture(t, "transmissionMap", o.transmissionTexture)), Promise.all(i);
  }
}
class Ls {
  constructor(e) {
    this.parser = e, this.name = E.KHR_MATERIALS_VOLUME;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : H;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, s = n.json.materials[e];
    if (!s.extensions || !s.extensions[this.name])
      return Promise.resolve();
    const i = [], o = s.extensions[this.name];
    t.thickness = o.thicknessFactor !== void 0 ? o.thicknessFactor : 0, o.thicknessTexture !== void 0 && i.push(n.assignTexture(t, "thicknessMap", o.thicknessTexture)), t.attenuationDistance = o.attenuationDistance || 1 / 0;
    const c = o.attenuationColor || [1, 1, 1];
    return t.attenuationColor = new v().setRGB(c[0], c[1], c[2], z), Promise.all(i);
  }
}
class Is {
  constructor(e) {
    this.parser = e, this.name = E.KHR_MATERIALS_IOR;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : H;
  }
  extendMaterialParams(e, t) {
    const s = this.parser.json.materials[e];
    if (!s.extensions || !s.extensions[this.name])
      return Promise.resolve();
    const i = s.extensions[this.name];
    return t.ior = i.ior !== void 0 ? i.ior : 1.5, Promise.resolve();
  }
}
class Ps {
  constructor(e) {
    this.parser = e, this.name = E.KHR_MATERIALS_SPECULAR;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : H;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, s = n.json.materials[e];
    if (!s.extensions || !s.extensions[this.name])
      return Promise.resolve();
    const i = [], o = s.extensions[this.name];
    t.specularIntensity = o.specularFactor !== void 0 ? o.specularFactor : 1, o.specularTexture !== void 0 && i.push(n.assignTexture(t, "specularIntensityMap", o.specularTexture));
    const c = o.specularColorFactor || [1, 1, 1];
    return t.specularColor = new v().setRGB(c[0], c[1], c[2], z), o.specularColorTexture !== void 0 && i.push(n.assignTexture(t, "specularColorMap", o.specularColorTexture, F)), Promise.all(i);
  }
}
class Cs {
  constructor(e) {
    this.parser = e, this.name = E.EXT_MATERIALS_BUMP;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : H;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, s = n.json.materials[e];
    if (!s.extensions || !s.extensions[this.name])
      return Promise.resolve();
    const i = [], o = s.extensions[this.name];
    return t.bumpScale = o.bumpFactor !== void 0 ? o.bumpFactor : 1, o.bumpTexture !== void 0 && i.push(n.assignTexture(t, "bumpMap", o.bumpTexture)), Promise.all(i);
  }
}
class Ds {
  constructor(e) {
    this.parser = e, this.name = E.KHR_MATERIALS_ANISOTROPY;
  }
  getMaterialType(e) {
    const n = this.parser.json.materials[e];
    return !n.extensions || !n.extensions[this.name] ? null : H;
  }
  extendMaterialParams(e, t) {
    const n = this.parser, s = n.json.materials[e];
    if (!s.extensions || !s.extensions[this.name])
      return Promise.resolve();
    const i = [], o = s.extensions[this.name];
    return o.anisotropyStrength !== void 0 && (t.anisotropy = o.anisotropyStrength), o.anisotropyRotation !== void 0 && (t.anisotropyRotation = o.anisotropyRotation), o.anisotropyTexture !== void 0 && i.push(n.assignTexture(t, "anisotropyMap", o.anisotropyTexture)), Promise.all(i);
  }
}
class Os {
  constructor(e) {
    this.parser = e, this.name = E.KHR_TEXTURE_BASISU;
  }
  loadTexture(e) {
    const t = this.parser, n = t.json, s = n.textures[e];
    if (!s.extensions || !s.extensions[this.name])
      return null;
    const i = s.extensions[this.name], o = t.options.ktx2Loader;
    if (!o) {
      if (n.extensionsRequired && n.extensionsRequired.indexOf(this.name) >= 0)
        throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
      return null;
    }
    return t.loadTextureImage(e, i.source, o);
  }
}
class Ns {
  constructor(e) {
    this.parser = e, this.name = E.EXT_TEXTURE_WEBP, this.isSupported = null;
  }
  loadTexture(e) {
    const t = this.name, n = this.parser, s = n.json, i = s.textures[e];
    if (!i.extensions || !i.extensions[t])
      return null;
    const o = i.extensions[t], c = s.images[o.source];
    let a = n.textureLoader;
    if (c.uri) {
      const l = n.options.manager.getHandler(c.uri);
      l !== null && (a = l);
    }
    return this.detectSupport().then(function(l) {
      if (l) return n.loadTextureImage(e, o.source, a);
      if (s.extensionsRequired && s.extensionsRequired.indexOf(t) >= 0)
        throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
      return n.loadTexture(e);
    });
  }
  detectSupport() {
    return this.isSupported || (this.isSupported = new Promise(function(e) {
      const t = new Image();
      t.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA", t.onload = t.onerror = function() {
        e(t.height === 1);
      };
    })), this.isSupported;
  }
}
class ks {
  constructor(e) {
    this.parser = e, this.name = E.EXT_TEXTURE_AVIF, this.isSupported = null;
  }
  loadTexture(e) {
    const t = this.name, n = this.parser, s = n.json, i = s.textures[e];
    if (!i.extensions || !i.extensions[t])
      return null;
    const o = i.extensions[t], c = s.images[o.source];
    let a = n.textureLoader;
    if (c.uri) {
      const l = n.options.manager.getHandler(c.uri);
      l !== null && (a = l);
    }
    return this.detectSupport().then(function(l) {
      if (l) return n.loadTextureImage(e, o.source, a);
      if (s.extensionsRequired && s.extensionsRequired.indexOf(t) >= 0)
        throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
      return n.loadTexture(e);
    });
  }
  detectSupport() {
    return this.isSupported || (this.isSupported = new Promise(function(e) {
      const t = new Image();
      t.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=", t.onload = t.onerror = function() {
        e(t.height === 1);
      };
    })), this.isSupported;
  }
}
class vs {
  constructor(e) {
    this.name = E.EXT_MESHOPT_COMPRESSION, this.parser = e;
  }
  loadBufferView(e) {
    const t = this.parser.json, n = t.bufferViews[e];
    if (n.extensions && n.extensions[this.name]) {
      const s = n.extensions[this.name], i = this.parser.getDependency("buffer", s.buffer), o = this.parser.options.meshoptDecoder;
      if (!o || !o.supported) {
        if (t.extensionsRequired && t.extensionsRequired.indexOf(this.name) >= 0)
          throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
        return null;
      }
      return i.then(function(c) {
        const a = s.byteOffset || 0, l = s.byteLength || 0, u = s.count, h = s.byteStride, d = new Uint8Array(c, a, l);
        return o.decodeGltfBufferAsync ? o.decodeGltfBufferAsync(u, h, d, s.mode, s.filter).then(function(p) {
          return p.buffer;
        }) : o.ready.then(function() {
          const p = new ArrayBuffer(u * h);
          return o.decodeGltfBuffer(new Uint8Array(p), u, h, d, s.mode, s.filter), p;
        });
      });
    } else
      return null;
  }
}
class js {
  constructor(e) {
    this.name = E.EXT_MESH_GPU_INSTANCING, this.parser = e;
  }
  createNodeMesh(e) {
    const t = this.parser.json, n = t.nodes[e];
    if (!n.extensions || !n.extensions[this.name] || n.mesh === void 0)
      return null;
    const s = t.meshes[n.mesh];
    for (const l of s.primitives)
      if (l.mode !== N.TRIANGLES && l.mode !== N.TRIANGLE_STRIP && l.mode !== N.TRIANGLE_FAN && l.mode !== void 0)
        return null;
    const o = n.extensions[this.name].attributes, c = [], a = {};
    for (const l in o)
      c.push(this.parser.getDependency("accessor", o[l]).then((u) => (a[l] = u, a[l])));
    return c.length < 1 ? null : (c.push(this.parser.createNodeMesh(e)), Promise.all(c).then((l) => {
      const u = l.pop(), h = u.isGroup ? u.children : [u], d = l[0].count, p = [];
      for (const y of h) {
        const T = new Q(), f = new S(), m = new le(), g = new S(1, 1, 1), w = new Rt(y.geometry, y.material, d);
        for (let _ = 0; _ < d; _++)
          a.TRANSLATION && f.fromBufferAttribute(a.TRANSLATION, _), a.ROTATION && m.fromBufferAttribute(a.ROTATION, _), a.SCALE && g.fromBufferAttribute(a.SCALE, _), w.setMatrixAt(_, T.compose(f, m, g));
        for (const _ in a)
          if (_ === "_COLOR_0") {
            const M = a[_];
            w.instanceColor = new St(M.array, M.itemSize, M.normalized);
          } else _ !== "TRANSLATION" && _ !== "ROTATION" && _ !== "SCALE" && y.geometry.setAttribute(_, a[_]);
        tt.prototype.copy.call(w, y), this.parser.assignFinalMaterial(w), p.push(w);
      }
      return u.isGroup ? (u.clear(), u.add(...p), u) : p[0];
    }));
  }
}
const ht = "glTF", J = 12, ze = { JSON: 1313821514, BIN: 5130562 };
class Fs {
  constructor(e) {
    this.name = E.KHR_BINARY_GLTF, this.content = null, this.body = null;
    const t = new DataView(e, 0, J), n = new TextDecoder();
    if (this.header = {
      magic: n.decode(new Uint8Array(e.slice(0, 4))),
      version: t.getUint32(4, !0),
      length: t.getUint32(8, !0)
    }, this.header.magic !== ht)
      throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
    if (this.header.version < 2)
      throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
    const s = this.header.length - J, i = new DataView(e, J);
    let o = 0;
    for (; o < s; ) {
      const c = i.getUint32(o, !0);
      o += 4;
      const a = i.getUint32(o, !0);
      if (o += 4, a === ze.JSON) {
        const l = new Uint8Array(e, J + o, c);
        this.content = n.decode(l);
      } else if (a === ze.BIN) {
        const l = J + o;
        this.body = e.slice(l, l + c);
      }
      o += c;
    }
    if (this.content === null)
      throw new Error("THREE.GLTFLoader: JSON content not found.");
  }
}
class Us {
  constructor(e, t) {
    if (!t)
      throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
    this.name = E.KHR_DRACO_MESH_COMPRESSION, this.json = e, this.dracoLoader = t, this.dracoLoader.preload();
  }
  decodePrimitive(e, t) {
    const n = this.json, s = this.dracoLoader, i = e.extensions[this.name].bufferView, o = e.extensions[this.name].attributes, c = {}, a = {}, l = {};
    for (const u in o) {
      const h = Pe[u] || u.toLowerCase();
      c[h] = o[u];
    }
    for (const u in e.attributes) {
      const h = Pe[u] || u.toLowerCase();
      if (o[u] !== void 0) {
        const d = n.accessors[e.attributes[u]], p = Z[d.componentType];
        l[h] = p.name, a[h] = d.normalized === !0;
      }
    }
    return t.getDependency("bufferView", i).then(function(u) {
      return new Promise(function(h, d) {
        s.decodeDracoFile(u, function(p) {
          for (const y in p.attributes) {
            const T = p.attributes[y], f = a[y];
            f !== void 0 && (T.normalized = f);
          }
          h(p);
        }, c, l, z, d);
      });
    });
  }
}
class Hs {
  constructor() {
    this.name = E.KHR_TEXTURE_TRANSFORM;
  }
  extendTexture(e, t) {
    return (t.texCoord === void 0 || t.texCoord === e.channel) && t.offset === void 0 && t.rotation === void 0 && t.scale === void 0 || (e = e.clone(), t.texCoord !== void 0 && (e.channel = t.texCoord), t.offset !== void 0 && e.offset.fromArray(t.offset), t.rotation !== void 0 && (e.rotation = t.rotation), t.scale !== void 0 && e.repeat.fromArray(t.scale), e.needsUpdate = !0), e;
  }
}
class Bs {
  constructor() {
    this.name = E.KHR_MESH_QUANTIZATION;
  }
}
class ut extends Yt {
  constructor(e, t, n, s) {
    super(e, t, n, s);
  }
  copySampleValue_(e) {
    const t = this.resultBuffer, n = this.sampleValues, s = this.valueSize, i = e * s * 3 + s;
    for (let o = 0; o !== s; o++)
      t[o] = n[i + o];
    return t;
  }
  interpolate_(e, t, n, s) {
    const i = this.resultBuffer, o = this.sampleValues, c = this.valueSize, a = c * 2, l = c * 3, u = s - t, h = (n - t) / u, d = h * h, p = d * h, y = e * l, T = y - l, f = -2 * p + 3 * d, m = p - d, g = 1 - f, w = m - d + h;
    for (let _ = 0; _ !== c; _++) {
      const M = o[T + _ + c], A = o[T + _ + a] * u, b = o[y + _ + c], R = o[y + _] * u;
      i[_] = g * M + w * A + f * b + m * R;
    }
    return i;
  }
}
const Gs = new le();
class zs extends ut {
  interpolate_(e, t, n, s) {
    const i = super.interpolate_(e, t, n, s);
    return Gs.fromArray(i).normalize().toArray(i), i;
  }
}
const N = {
  POINTS: 0,
  LINES: 1,
  LINE_LOOP: 2,
  LINE_STRIP: 3,
  TRIANGLES: 4,
  TRIANGLE_STRIP: 5,
  TRIANGLE_FAN: 6
}, Z = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
}, Ke = {
  9728: it,
  9729: Se,
  9984: Ot,
  9985: Dt,
  9986: Ct,
  9987: nt
}, Ve = {
  33071: kt,
  33648: Nt,
  10497: he
}, Te = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, Pe = {
  POSITION: "position",
  NORMAL: "normal",
  TANGENT: "tangent",
  TEXCOORD_0: "uv",
  TEXCOORD_1: "uv1",
  TEXCOORD_2: "uv2",
  TEXCOORD_3: "uv3",
  COLOR_0: "color",
  WEIGHTS_0: "skinWeight",
  JOINTS_0: "skinIndex"
}, K = {
  scale: "scale",
  translation: "position",
  rotation: "quaternion",
  weights: "morphTargetInfluences"
}, Ks = {
  CUBICSPLINE: void 0,
  // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
  // keyframe track will be initialized with a default interpolation type, then modified.
  LINEAR: rt,
  STEP: Xt
}, be = {
  OPAQUE: "OPAQUE",
  MASK: "MASK",
  BLEND: "BLEND"
};
function Vs(r) {
  return r.DefaultMaterial === void 0 && (r.DefaultMaterial = new ot({
    color: 16777215,
    emissive: 0,
    metalness: 1,
    roughness: 1,
    transparent: !1,
    depthTest: !0,
    side: at
  })), r.DefaultMaterial;
}
function X(r, e, t) {
  for (const n in t.extensions)
    r[n] === void 0 && (e.userData.gltfExtensions = e.userData.gltfExtensions || {}, e.userData.gltfExtensions[n] = t.extensions[n]);
}
function B(r, e) {
  e.extras !== void 0 && (typeof e.extras == "object" ? Object.assign(r.userData, e.extras) : console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + e.extras));
}
function Xs(r, e, t) {
  let n = !1, s = !1, i = !1;
  for (let l = 0, u = e.length; l < u; l++) {
    const h = e[l];
    if (h.POSITION !== void 0 && (n = !0), h.NORMAL !== void 0 && (s = !0), h.COLOR_0 !== void 0 && (i = !0), n && s && i) break;
  }
  if (!n && !s && !i) return Promise.resolve(r);
  const o = [], c = [], a = [];
  for (let l = 0, u = e.length; l < u; l++) {
    const h = e[l];
    if (n) {
      const d = h.POSITION !== void 0 ? t.getDependency("accessor", h.POSITION) : r.attributes.position;
      o.push(d);
    }
    if (s) {
      const d = h.NORMAL !== void 0 ? t.getDependency("accessor", h.NORMAL) : r.attributes.normal;
      c.push(d);
    }
    if (i) {
      const d = h.COLOR_0 !== void 0 ? t.getDependency("accessor", h.COLOR_0) : r.attributes.color;
      a.push(d);
    }
  }
  return Promise.all([
    Promise.all(o),
    Promise.all(c),
    Promise.all(a)
  ]).then(function(l) {
    const u = l[0], h = l[1], d = l[2];
    return n && (r.morphAttributes.position = u), s && (r.morphAttributes.normal = h), i && (r.morphAttributes.color = d), r.morphTargetsRelative = !0, r;
  });
}
function Ys(r, e) {
  if (r.updateMorphTargets(), e.weights !== void 0)
    for (let t = 0, n = e.weights.length; t < n; t++)
      r.morphTargetInfluences[t] = e.weights[t];
  if (e.extras && Array.isArray(e.extras.targetNames)) {
    const t = e.extras.targetNames;
    if (r.morphTargetInfluences.length === t.length) {
      r.morphTargetDictionary = {};
      for (let n = 0, s = t.length; n < s; n++)
        r.morphTargetDictionary[t[n]] = n;
    } else
      console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
  }
}
function Ws(r) {
  let e;
  const t = r.extensions && r.extensions[E.KHR_DRACO_MESH_COMPRESSION];
  if (t ? e = "draco:" + t.bufferView + ":" + t.indices + ":" + we(t.attributes) : e = r.indices + ":" + we(r.attributes) + ":" + r.mode, r.targets !== void 0)
    for (let n = 0, s = r.targets.length; n < s; n++)
      e += ":" + we(r.targets[n]);
  return e;
}
function we(r) {
  let e = "";
  const t = Object.keys(r).sort();
  for (let n = 0, s = t.length; n < s; n++)
    e += t[n] + ":" + r[t[n]] + ";";
  return e;
}
function Ce(r) {
  switch (r) {
    case Int8Array:
      return 1 / 127;
    case Uint8Array:
      return 1 / 255;
    case Int16Array:
      return 1 / 32767;
    case Uint16Array:
      return 1 / 65535;
    default:
      throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
  }
}
function qs(r) {
  return r.search(/\.jpe?g($|\?)/i) > 0 || r.search(/^data\:image\/jpeg/) === 0 ? "image/jpeg" : r.search(/\.webp($|\?)/i) > 0 || r.search(/^data\:image\/webp/) === 0 ? "image/webp" : r.search(/\.ktx2($|\?)/i) > 0 || r.search(/^data\:image\/ktx2/) === 0 ? "image/ktx2" : "image/png";
}
const Zs = new Q();
class Qs {
  constructor(e = {}, t = {}) {
    this.json = e, this.extensions = {}, this.plugins = {}, this.options = t, this.cache = new ys(), this.associations = /* @__PURE__ */ new Map(), this.primitiveCache = {}, this.nodeCache = {}, this.meshCache = { refs: {}, uses: {} }, this.cameraCache = { refs: {}, uses: {} }, this.lightCache = { refs: {}, uses: {} }, this.sourceCache = {}, this.textureCache = {}, this.nodeNamesUsed = {};
    let n = !1, s = -1, i = !1, o = -1;
    if (typeof navigator < "u") {
      const c = navigator.userAgent;
      n = /^((?!chrome|android).)*safari/i.test(c) === !0;
      const a = c.match(/Version\/(\d+)/);
      s = n && a ? parseInt(a[1], 10) : -1, i = c.indexOf("Firefox") > -1, o = i ? c.match(/Firefox\/([0-9]+)\./)[1] : -1;
    }
    typeof createImageBitmap > "u" || n && s < 17 || i && o < 98 ? this.textureLoader = new st(this.options.manager) : this.textureLoader = new Lt(this.options.manager), this.textureLoader.setCrossOrigin(this.options.crossOrigin), this.textureLoader.setRequestHeader(this.options.requestHeader), this.fileLoader = new fe(this.options.manager), this.fileLoader.setResponseType("arraybuffer"), this.options.crossOrigin === "use-credentials" && this.fileLoader.setWithCredentials(!0);
  }
  setExtensions(e) {
    this.extensions = e;
  }
  setPlugins(e) {
    this.plugins = e;
  }
  parse(e, t) {
    const n = this, s = this.json, i = this.extensions;
    this.cache.removeAll(), this.nodeCache = {}, this._invokeAll(function(o) {
      return o._markDefs && o._markDefs();
    }), Promise.all(this._invokeAll(function(o) {
      return o.beforeRoot && o.beforeRoot();
    })).then(function() {
      return Promise.all([
        n.getDependencies("scene"),
        n.getDependencies("animation"),
        n.getDependencies("camera")
      ]);
    }).then(function(o) {
      const c = {
        scene: o[0][s.scene || 0],
        scenes: o[0],
        animations: o[1],
        cameras: o[2],
        asset: s.asset,
        parser: n,
        userData: {}
      };
      return X(i, c, s), B(c, s), Promise.all(n._invokeAll(function(a) {
        return a.afterRoot && a.afterRoot(c);
      })).then(function() {
        for (const a of c.scenes)
          a.updateMatrixWorld();
        e(c);
      });
    }).catch(t);
  }
  /**
   * Marks the special nodes/meshes in json for efficient parse.
   */
  _markDefs() {
    const e = this.json.nodes || [], t = this.json.skins || [], n = this.json.meshes || [];
    for (let s = 0, i = t.length; s < i; s++) {
      const o = t[s].joints;
      for (let c = 0, a = o.length; c < a; c++)
        e[o[c]].isBone = !0;
    }
    for (let s = 0, i = e.length; s < i; s++) {
      const o = e[s];
      o.mesh !== void 0 && (this._addNodeRef(this.meshCache, o.mesh), o.skin !== void 0 && (n[o.mesh].isSkinnedMesh = !0)), o.camera !== void 0 && this._addNodeRef(this.cameraCache, o.camera);
    }
  }
  /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   */
  _addNodeRef(e, t) {
    t !== void 0 && (e.refs[t] === void 0 && (e.refs[t] = e.uses[t] = 0), e.refs[t]++);
  }
  /** Returns a reference to a shared resource, cloning it if necessary. */
  _getNodeRef(e, t, n) {
    if (e.refs[t] <= 1) return n;
    const s = n.clone(), i = (o, c) => {
      const a = this.associations.get(o);
      a != null && this.associations.set(c, a);
      for (const [l, u] of o.children.entries())
        i(u, c.children[l]);
    };
    return i(n, s), s.name += "_instance_" + e.uses[t]++, s;
  }
  _invokeOne(e) {
    const t = Object.values(this.plugins);
    t.push(this);
    for (let n = 0; n < t.length; n++) {
      const s = e(t[n]);
      if (s) return s;
    }
    return null;
  }
  _invokeAll(e) {
    const t = Object.values(this.plugins);
    t.unshift(this);
    const n = [];
    for (let s = 0; s < t.length; s++) {
      const i = e(t[s]);
      i && n.push(i);
    }
    return n;
  }
  /**
   * Requests the specified dependency asynchronously, with caching.
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */
  getDependency(e, t) {
    const n = e + ":" + t;
    let s = this.cache.get(n);
    if (!s) {
      switch (e) {
        case "scene":
          s = this.loadScene(t);
          break;
        case "node":
          s = this._invokeOne(function(i) {
            return i.loadNode && i.loadNode(t);
          });
          break;
        case "mesh":
          s = this._invokeOne(function(i) {
            return i.loadMesh && i.loadMesh(t);
          });
          break;
        case "accessor":
          s = this.loadAccessor(t);
          break;
        case "bufferView":
          s = this._invokeOne(function(i) {
            return i.loadBufferView && i.loadBufferView(t);
          });
          break;
        case "buffer":
          s = this.loadBuffer(t);
          break;
        case "material":
          s = this._invokeOne(function(i) {
            return i.loadMaterial && i.loadMaterial(t);
          });
          break;
        case "texture":
          s = this._invokeOne(function(i) {
            return i.loadTexture && i.loadTexture(t);
          });
          break;
        case "skin":
          s = this.loadSkin(t);
          break;
        case "animation":
          s = this._invokeOne(function(i) {
            return i.loadAnimation && i.loadAnimation(t);
          });
          break;
        case "camera":
          s = this.loadCamera(t);
          break;
        default:
          if (s = this._invokeOne(function(i) {
            return i != this && i.getDependency && i.getDependency(e, t);
          }), !s)
            throw new Error("Unknown type: " + e);
          break;
      }
      this.cache.add(n, s);
    }
    return s;
  }
  /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */
  getDependencies(e) {
    let t = this.cache.get(e);
    if (!t) {
      const n = this, s = this.json[e + (e === "mesh" ? "es" : "s")] || [];
      t = Promise.all(s.map(function(i, o) {
        return n.getDependency(e, o);
      })), this.cache.add(e, t);
    }
    return t;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBuffer(e) {
    const t = this.json.buffers[e], n = this.fileLoader;
    if (t.type && t.type !== "arraybuffer")
      throw new Error("THREE.GLTFLoader: " + t.type + " buffer type is not supported.");
    if (t.uri === void 0 && e === 0)
      return Promise.resolve(this.extensions[E.KHR_BINARY_GLTF].body);
    const s = this.options;
    return new Promise(function(i, o) {
      n.load(q.resolveURL(t.uri, s.path), i, void 0, function() {
        o(new Error('THREE.GLTFLoader: Failed to load buffer "' + t.uri + '".'));
      });
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */
  loadBufferView(e) {
    const t = this.json.bufferViews[e];
    return this.getDependency("buffer", t.buffer).then(function(n) {
      const s = t.byteLength || 0, i = t.byteOffset || 0;
      return n.slice(i, i + s);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */
  loadAccessor(e) {
    const t = this, n = this.json, s = this.json.accessors[e];
    if (s.bufferView === void 0 && s.sparse === void 0) {
      const o = Te[s.type], c = Z[s.componentType], a = s.normalized === !0, l = new c(s.count * o);
      return Promise.resolve(new _e(l, o, a));
    }
    const i = [];
    return s.bufferView !== void 0 ? i.push(this.getDependency("bufferView", s.bufferView)) : i.push(null), s.sparse !== void 0 && (i.push(this.getDependency("bufferView", s.sparse.indices.bufferView)), i.push(this.getDependency("bufferView", s.sparse.values.bufferView))), Promise.all(i).then(function(o) {
      const c = o[0], a = Te[s.type], l = Z[s.componentType], u = l.BYTES_PER_ELEMENT, h = u * a, d = s.byteOffset || 0, p = s.bufferView !== void 0 ? n.bufferViews[s.bufferView].byteStride : void 0, y = s.normalized === !0;
      let T, f;
      if (p && p !== h) {
        const m = Math.floor(d / p), g = "InterleavedBuffer:" + s.bufferView + ":" + s.componentType + ":" + m + ":" + s.count;
        let w = t.cache.get(g);
        w || (T = new l(c, m * p, s.count * p / u), w = new It(T, p / u), t.cache.add(g, w)), f = new Pt(w, a, d % p / u, y);
      } else
        c === null ? T = new l(s.count * a) : T = new l(c, d, s.count * a), f = new _e(T, a, y);
      if (s.sparse !== void 0) {
        const m = Te.SCALAR, g = Z[s.sparse.indices.componentType], w = s.sparse.indices.byteOffset || 0, _ = s.sparse.values.byteOffset || 0, M = new g(o[1], w, s.sparse.count * m), A = new l(o[2], _, s.sparse.count * a);
        c !== null && (f = new _e(f.array.slice(), f.itemSize, f.normalized)), f.normalized = !1;
        for (let b = 0, R = M.length; b < R; b++) {
          const I = M[b];
          if (f.setX(I, A[b * a]), a >= 2 && f.setY(I, A[b * a + 1]), a >= 3 && f.setZ(I, A[b * a + 2]), a >= 4 && f.setW(I, A[b * a + 3]), a >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
        }
        f.normalized = y;
      }
      return f;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture|null>}
   */
  loadTexture(e) {
    const t = this.json, n = this.options, i = t.textures[e].source, o = t.images[i];
    let c = this.textureLoader;
    if (o.uri) {
      const a = n.manager.getHandler(o.uri);
      a !== null && (c = a);
    }
    return this.loadTextureImage(e, i, c);
  }
  loadTextureImage(e, t, n) {
    const s = this, i = this.json, o = i.textures[e], c = i.images[t], a = (c.uri || c.bufferView) + ":" + o.sampler;
    if (this.textureCache[a])
      return this.textureCache[a];
    const l = this.loadImageSource(t, n).then(function(u) {
      u.flipY = !1, u.name = o.name || c.name || "", u.name === "" && typeof c.uri == "string" && c.uri.startsWith("data:image/") === !1 && (u.name = c.uri);
      const d = (i.samplers || {})[o.sampler] || {};
      return u.magFilter = Ke[d.magFilter] || Se, u.minFilter = Ke[d.minFilter] || nt, u.wrapS = Ve[d.wrapS] || he, u.wrapT = Ve[d.wrapT] || he, u.generateMipmaps = !u.isCompressedTexture && u.minFilter !== it && u.minFilter !== Se, s.associations.set(u, { textures: e }), u;
    }).catch(function() {
      return null;
    });
    return this.textureCache[a] = l, l;
  }
  loadImageSource(e, t) {
    const n = this, s = this.json, i = this.options;
    if (this.sourceCache[e] !== void 0)
      return this.sourceCache[e].then((h) => h.clone());
    const o = s.images[e], c = self.URL || self.webkitURL;
    let a = o.uri || "", l = !1;
    if (o.bufferView !== void 0)
      a = n.getDependency("bufferView", o.bufferView).then(function(h) {
        l = !0;
        const d = new Blob([h], { type: o.mimeType });
        return a = c.createObjectURL(d), a;
      });
    else if (o.uri === void 0)
      throw new Error("THREE.GLTFLoader: Image " + e + " is missing URI and bufferView");
    const u = Promise.resolve(a).then(function(h) {
      return new Promise(function(d, p) {
        let y = d;
        t.isImageBitmapLoader === !0 && (y = function(T) {
          const f = new ve(T);
          f.needsUpdate = !0, d(f);
        }), t.load(q.resolveURL(h, i.path), y, void 0, p);
      });
    }).then(function(h) {
      return l === !0 && c.revokeObjectURL(a), B(h, o), h.userData.mimeType = o.mimeType || qs(o.uri), h;
    }).catch(function(h) {
      throw console.error("THREE.GLTFLoader: Couldn't load texture", a), h;
    });
    return this.sourceCache[e] = u, u;
  }
  /**
   * Asynchronously assigns a texture to the given material parameters.
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @return {Promise<Texture>}
   */
  assignTexture(e, t, n, s) {
    const i = this;
    return this.getDependency("texture", n.index).then(function(o) {
      if (!o) return null;
      if (n.texCoord !== void 0 && n.texCoord > 0 && (o = o.clone(), o.channel = n.texCoord), i.extensions[E.KHR_TEXTURE_TRANSFORM]) {
        const c = n.extensions !== void 0 ? n.extensions[E.KHR_TEXTURE_TRANSFORM] : void 0;
        if (c) {
          const a = i.associations.get(o);
          o = i.extensions[E.KHR_TEXTURE_TRANSFORM].extendTexture(o, c), i.associations.set(o, a);
        }
      }
      return s !== void 0 && (o.colorSpace = s), e[t] = o, o;
    });
  }
  /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   * @param  {Object3D} mesh Mesh, Line, or Points instance.
   */
  assignFinalMaterial(e) {
    const t = e.geometry;
    let n = e.material;
    const s = t.attributes.tangent === void 0, i = t.attributes.color !== void 0, o = t.attributes.normal === void 0;
    if (e.isPoints) {
      const c = "PointsMaterial:" + n.uuid;
      let a = this.cache.get(c);
      a || (a = new ee(), se.prototype.copy.call(a, n), a.color.copy(n.color), a.map = n.map, a.sizeAttenuation = !1, this.cache.add(c, a)), n = a;
    } else if (e.isLine) {
      const c = "LineBasicMaterial:" + n.uuid;
      let a = this.cache.get(c);
      a || (a = new re(), se.prototype.copy.call(a, n), a.color.copy(n.color), a.map = n.map, this.cache.add(c, a)), n = a;
    }
    if (s || i || o) {
      let c = "ClonedMaterial:" + n.uuid + ":";
      s && (c += "derivative-tangents:"), i && (c += "vertex-colors:"), o && (c += "flat-shading:");
      let a = this.cache.get(c);
      a || (a = n.clone(), i && (a.vertexColors = !0), o && (a.flatShading = !0), s && (a.normalScale && (a.normalScale.y *= -1), a.clearcoatNormalScale && (a.clearcoatNormalScale.y *= -1)), this.cache.add(c, a), this.associations.set(a, this.associations.get(n))), n = a;
    }
    e.material = n;
  }
  getMaterialType() {
    return ot;
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */
  loadMaterial(e) {
    const t = this, n = this.json, s = this.extensions, i = n.materials[e];
    let o;
    const c = {}, a = i.extensions || {}, l = [];
    if (a[E.KHR_MATERIALS_UNLIT]) {
      const h = s[E.KHR_MATERIALS_UNLIT];
      o = h.getMaterialType(), l.push(h.extendParams(c, i, t));
    } else {
      const h = i.pbrMetallicRoughness || {};
      if (c.color = new v(1, 1, 1), c.opacity = 1, Array.isArray(h.baseColorFactor)) {
        const d = h.baseColorFactor;
        c.color.setRGB(d[0], d[1], d[2], z), c.opacity = d[3];
      }
      h.baseColorTexture !== void 0 && l.push(t.assignTexture(c, "map", h.baseColorTexture, F)), c.metalness = h.metallicFactor !== void 0 ? h.metallicFactor : 1, c.roughness = h.roughnessFactor !== void 0 ? h.roughnessFactor : 1, h.metallicRoughnessTexture !== void 0 && (l.push(t.assignTexture(c, "metalnessMap", h.metallicRoughnessTexture)), l.push(t.assignTexture(c, "roughnessMap", h.metallicRoughnessTexture))), o = this._invokeOne(function(d) {
        return d.getMaterialType && d.getMaterialType(e);
      }), l.push(Promise.all(this._invokeAll(function(d) {
        return d.extendMaterialParams && d.extendMaterialParams(e, c);
      })));
    }
    i.doubleSided === !0 && (c.side = vt);
    const u = i.alphaMode || be.OPAQUE;
    if (u === be.BLEND ? (c.transparent = !0, c.depthWrite = !1) : (c.transparent = !1, u === be.MASK && (c.alphaTest = i.alphaCutoff !== void 0 ? i.alphaCutoff : 0.5)), i.normalTexture !== void 0 && o !== te && (l.push(t.assignTexture(c, "normalMap", i.normalTexture)), c.normalScale = new C(1, 1), i.normalTexture.scale !== void 0)) {
      const h = i.normalTexture.scale;
      c.normalScale.set(h, h);
    }
    if (i.occlusionTexture !== void 0 && o !== te && (l.push(t.assignTexture(c, "aoMap", i.occlusionTexture)), i.occlusionTexture.strength !== void 0 && (c.aoMapIntensity = i.occlusionTexture.strength)), i.emissiveFactor !== void 0 && o !== te) {
      const h = i.emissiveFactor;
      c.emissive = new v().setRGB(h[0], h[1], h[2], z);
    }
    return i.emissiveTexture !== void 0 && o !== te && l.push(t.assignTexture(c, "emissiveMap", i.emissiveTexture, F)), Promise.all(l).then(function() {
      const h = new o(c);
      return i.name && (h.name = i.name), B(h, i), t.associations.set(h, { materials: e }), i.extensions && X(s, h, i), h;
    });
  }
  /** When Object3D instances are targeted by animation, they need unique names. */
  createUniqueName(e) {
    const t = jt.sanitizeNodeName(e || "");
    return t in this.nodeNamesUsed ? t + "_" + ++this.nodeNamesUsed[t] : (this.nodeNamesUsed[t] = 0, t);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */
  loadGeometries(e) {
    const t = this, n = this.extensions, s = this.primitiveCache;
    function i(c) {
      return n[E.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(c, t).then(function(a) {
        return Xe(a, c, t);
      });
    }
    const o = [];
    for (let c = 0, a = e.length; c < a; c++) {
      const l = e[c], u = Ws(l), h = s[u];
      if (h)
        o.push(h.promise);
      else {
        let d;
        l.extensions && l.extensions[E.KHR_DRACO_MESH_COMPRESSION] ? d = i(l) : d = Xe(new ue(), l, t), s[u] = { primitive: l, promise: d }, o.push(d);
      }
    }
    return Promise.all(o);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh>}
   */
  loadMesh(e) {
    const t = this, n = this.json, s = this.extensions, i = n.meshes[e], o = i.primitives, c = [];
    for (let a = 0, l = o.length; a < l; a++) {
      const u = o[a].material === void 0 ? Vs(this.cache) : this.getDependency("material", o[a].material);
      c.push(u);
    }
    return c.push(t.loadGeometries(o)), Promise.all(c).then(function(a) {
      const l = a.slice(0, a.length - 1), u = a[a.length - 1], h = [];
      for (let p = 0, y = u.length; p < y; p++) {
        const T = u[p], f = o[p];
        let m;
        const g = l[p];
        if (f.mode === N.TRIANGLES || f.mode === N.TRIANGLE_STRIP || f.mode === N.TRIANGLE_FAN || f.mode === void 0)
          m = i.isSkinnedMesh === !0 ? new Ft(T, g) : new de(T, g), m.isSkinnedMesh === !0 && m.normalizeSkinWeights(), f.mode === N.TRIANGLE_STRIP ? m.geometry = Ge(m.geometry, et) : f.mode === N.TRIANGLE_FAN && (m.geometry = Ge(m.geometry, Re));
        else if (f.mode === N.LINES)
          m = new Le(T, g);
        else if (f.mode === N.LINE_STRIP)
          m = new Ut(T, g);
        else if (f.mode === N.LINE_LOOP)
          m = new Ht(T, g);
        else if (f.mode === N.POINTS)
          m = new ae(T, g);
        else
          throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + f.mode);
        Object.keys(m.geometry.morphAttributes).length > 0 && Ys(m, i), m.name = t.createUniqueName(i.name || "mesh_" + e), B(m, i), f.extensions && X(s, m, f), t.assignFinalMaterial(m), h.push(m);
      }
      for (let p = 0, y = h.length; p < y; p++)
        t.associations.set(h[p], {
          meshes: e,
          primitives: p
        });
      if (h.length === 1)
        return i.extensions && X(s, h[0], i), h[0];
      const d = new ce();
      i.extensions && X(s, d, i), t.associations.set(d, { meshes: e });
      for (let p = 0, y = h.length; p < y; p++)
        d.add(h[p]);
      return d;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */
  loadCamera(e) {
    let t;
    const n = this.json.cameras[e], s = n[n.type];
    if (!s) {
      console.warn("THREE.GLTFLoader: Missing camera parameters.");
      return;
    }
    return n.type === "perspective" ? t = new Bt(Je.radToDeg(s.yfov), s.aspectRatio || 1, s.znear || 1, s.zfar || 2e6) : n.type === "orthographic" && (t = new Gt(-s.xmag, s.xmag, s.ymag, -s.ymag, s.znear, s.zfar)), n.name && (t.name = this.createUniqueName(n.name)), B(t, n), Promise.resolve(t);
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */
  loadSkin(e) {
    const t = this.json.skins[e], n = [];
    for (let s = 0, i = t.joints.length; s < i; s++)
      n.push(this._loadNodeShallow(t.joints[s]));
    return t.inverseBindMatrices !== void 0 ? n.push(this.getDependency("accessor", t.inverseBindMatrices)) : n.push(null), Promise.all(n).then(function(s) {
      const i = s.pop(), o = s, c = [], a = [];
      for (let l = 0, u = o.length; l < u; l++) {
        const h = o[l];
        if (h) {
          c.push(h);
          const d = new Q();
          i !== null && d.fromArray(i.array, l * 16), a.push(d);
        } else
          console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', t.joints[l]);
      }
      return new zt(c, a);
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */
  loadAnimation(e) {
    const t = this.json, n = this, s = t.animations[e], i = s.name ? s.name : "animation_" + e, o = [], c = [], a = [], l = [], u = [];
    for (let h = 0, d = s.channels.length; h < d; h++) {
      const p = s.channels[h], y = s.samplers[p.sampler], T = p.target, f = T.node, m = s.parameters !== void 0 ? s.parameters[y.input] : y.input, g = s.parameters !== void 0 ? s.parameters[y.output] : y.output;
      T.node !== void 0 && (o.push(this.getDependency("node", f)), c.push(this.getDependency("accessor", m)), a.push(this.getDependency("accessor", g)), l.push(y), u.push(T));
    }
    return Promise.all([
      Promise.all(o),
      Promise.all(c),
      Promise.all(a),
      Promise.all(l),
      Promise.all(u)
    ]).then(function(h) {
      const d = h[0], p = h[1], y = h[2], T = h[3], f = h[4], m = [];
      for (let g = 0, w = d.length; g < w; g++) {
        const _ = d[g], M = p[g], A = y[g], b = T[g], R = f[g];
        if (_ === void 0) continue;
        _.updateMatrix && _.updateMatrix();
        const I = n._createAnimationTracks(_, M, A, b, R);
        if (I)
          for (let j = 0; j < I.length; j++)
            m.push(I[j]);
      }
      return new Kt(i, void 0, m);
    });
  }
  createNodeMesh(e) {
    const t = this.json, n = this, s = t.nodes[e];
    return s.mesh === void 0 ? null : n.getDependency("mesh", s.mesh).then(function(i) {
      const o = n._getNodeRef(n.meshCache, s.mesh, i);
      return s.weights !== void 0 && o.traverse(function(c) {
        if (c.isMesh)
          for (let a = 0, l = s.weights.length; a < l; a++)
            c.morphTargetInfluences[a] = s.weights[a];
      }), o;
    });
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */
  loadNode(e) {
    const t = this.json, n = this, s = t.nodes[e], i = n._loadNodeShallow(e), o = [], c = s.children || [];
    for (let l = 0, u = c.length; l < u; l++)
      o.push(n.getDependency("node", c[l]));
    const a = s.skin === void 0 ? Promise.resolve(null) : n.getDependency("skin", s.skin);
    return Promise.all([
      i,
      Promise.all(o),
      a
    ]).then(function(l) {
      const u = l[0], h = l[1], d = l[2];
      d !== null && u.traverse(function(p) {
        p.isSkinnedMesh && p.bind(d, Zs);
      });
      for (let p = 0, y = h.length; p < y; p++)
        u.add(h[p]);
      return u;
    });
  }
  // ._loadNodeShallow() parses a single node.
  // skin and child nodes are created and added in .loadNode() (no '_' prefix).
  _loadNodeShallow(e) {
    const t = this.json, n = this.extensions, s = this;
    if (this.nodeCache[e] !== void 0)
      return this.nodeCache[e];
    const i = t.nodes[e], o = i.name ? s.createUniqueName(i.name) : "", c = [], a = s._invokeOne(function(l) {
      return l.createNodeMesh && l.createNodeMesh(e);
    });
    return a && c.push(a), i.camera !== void 0 && c.push(s.getDependency("camera", i.camera).then(function(l) {
      return s._getNodeRef(s.cameraCache, i.camera, l);
    })), s._invokeAll(function(l) {
      return l.createNodeAttachment && l.createNodeAttachment(e);
    }).forEach(function(l) {
      c.push(l);
    }), this.nodeCache[e] = Promise.all(c).then(function(l) {
      let u;
      if (i.isBone === !0 ? u = new Vt() : l.length > 1 ? u = new ce() : l.length === 1 ? u = l[0] : u = new tt(), u !== l[0])
        for (let h = 0, d = l.length; h < d; h++)
          u.add(l[h]);
      if (i.name && (u.userData.name = i.name, u.name = o), B(u, i), i.extensions && X(n, u, i), i.matrix !== void 0) {
        const h = new Q();
        h.fromArray(i.matrix), u.applyMatrix4(h);
      } else
        i.translation !== void 0 && u.position.fromArray(i.translation), i.rotation !== void 0 && u.quaternion.fromArray(i.rotation), i.scale !== void 0 && u.scale.fromArray(i.scale);
      return s.associations.has(u) || s.associations.set(u, {}), s.associations.get(u).nodes = e, u;
    }), this.nodeCache[e];
  }
  /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */
  loadScene(e) {
    const t = this.extensions, n = this.json.scenes[e], s = this, i = new ce();
    n.name && (i.name = s.createUniqueName(n.name)), B(i, n), n.extensions && X(t, i, n);
    const o = n.nodes || [], c = [];
    for (let a = 0, l = o.length; a < l; a++)
      c.push(s.getDependency("node", o[a]));
    return Promise.all(c).then(function(a) {
      for (let u = 0, h = a.length; u < h; u++)
        i.add(a[u]);
      const l = (u) => {
        const h = /* @__PURE__ */ new Map();
        for (const [d, p] of s.associations)
          (d instanceof se || d instanceof ve) && h.set(d, p);
        return u.traverse((d) => {
          const p = s.associations.get(d);
          p != null && h.set(d, p);
        }), h;
      };
      return s.associations = l(i), i;
    });
  }
  _createAnimationTracks(e, t, n, s, i) {
    const o = [], c = e.name ? e.name : e.uuid, a = [];
    K[i.path] === K.weights ? e.traverse(function(d) {
      d.morphTargetInfluences && a.push(d.name ? d.name : d.uuid);
    }) : a.push(c);
    let l;
    switch (K[i.path]) {
      case K.weights:
        l = Fe;
        break;
      case K.rotation:
        l = Ue;
        break;
      case K.position:
      case K.scale:
        l = je;
        break;
      default:
        switch (n.itemSize) {
          case 1:
            l = Fe;
            break;
          case 2:
          case 3:
          default:
            l = je;
            break;
        }
        break;
    }
    const u = s.interpolation !== void 0 ? Ks[s.interpolation] : rt, h = this._getArrayFromAccessor(n);
    for (let d = 0, p = a.length; d < p; d++) {
      const y = new l(
        a[d] + "." + K[i.path],
        t.array,
        h,
        u
      );
      s.interpolation === "CUBICSPLINE" && this._createCubicSplineTrackInterpolant(y), o.push(y);
    }
    return o;
  }
  _getArrayFromAccessor(e) {
    let t = e.array;
    if (e.normalized) {
      const n = Ce(t.constructor), s = new Float32Array(t.length);
      for (let i = 0, o = t.length; i < o; i++)
        s[i] = t[i] * n;
      t = s;
    }
    return t;
  }
  _createCubicSplineTrackInterpolant(e) {
    e.createInterpolant = function(n) {
      const s = this instanceof Ue ? zs : ut;
      return new s(this.times, this.values, this.getValueSize() / 3, n);
    }, e.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = !0;
  }
}
function $s(r, e, t) {
  const n = e.attributes, s = new Wt();
  if (n.POSITION !== void 0) {
    const c = t.json.accessors[n.POSITION], a = c.min, l = c.max;
    if (a !== void 0 && l !== void 0) {
      if (s.set(
        new S(a[0], a[1], a[2]),
        new S(l[0], l[1], l[2])
      ), c.normalized) {
        const u = Ce(Z[c.componentType]);
        s.min.multiplyScalar(u), s.max.multiplyScalar(u);
      }
    } else {
      console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      return;
    }
  } else
    return;
  const i = e.targets;
  if (i !== void 0) {
    const c = new S(), a = new S();
    for (let l = 0, u = i.length; l < u; l++) {
      const h = i[l];
      if (h.POSITION !== void 0) {
        const d = t.json.accessors[h.POSITION], p = d.min, y = d.max;
        if (p !== void 0 && y !== void 0) {
          if (a.setX(Math.max(Math.abs(p[0]), Math.abs(y[0]))), a.setY(Math.max(Math.abs(p[1]), Math.abs(y[1]))), a.setZ(Math.max(Math.abs(p[2]), Math.abs(y[2]))), d.normalized) {
            const T = Ce(Z[d.componentType]);
            a.multiplyScalar(T);
          }
          c.max(a);
        } else
          console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
      }
    }
    s.expandByVector(c);
  }
  r.boundingBox = s;
  const o = new qt();
  s.getCenter(o.center), o.radius = s.min.distanceTo(s.max) / 2, r.boundingSphere = o;
}
function Xe(r, e, t) {
  const n = e.attributes, s = [];
  function i(o, c) {
    return t.getDependency("accessor", o).then(function(a) {
      r.setAttribute(c, a);
    });
  }
  for (const o in n) {
    const c = Pe[o] || o.toLowerCase();
    c in r.attributes || s.push(i(n[o], c));
  }
  if (e.indices !== void 0 && !r.index) {
    const o = t.getDependency("accessor", e.indices).then(function(c) {
      r.setIndex(c);
    });
    s.push(o);
  }
  return ne.workingColorSpace !== z && "COLOR_0" in n && console.warn(`THREE.GLTFLoader: Converting vertex colors from "srgb-linear" to "${ne.workingColorSpace}" not supported.`), B(r, e), $s(r, e, t), Promise.all(s).then(function() {
    return e.targets !== void 0 ? Xs(r, e.targets, t) : r;
  });
}
const Js = /^[og]\s*(.+)?/, en = /^mtllib /, tn = /^usemtl /, sn = /^usemap /, Ye = /\s+/, We = new S(), xe = new S(), qe = new S(), Ze = new S(), O = new S(), oe = new v();
function nn() {
  const r = {
    objects: [],
    object: {},
    vertices: [],
    normals: [],
    colors: [],
    uvs: [],
    materials: {},
    materialLibraries: [],
    startObject: function(e, t) {
      if (this.object && this.object.fromDeclaration === !1) {
        this.object.name = e, this.object.fromDeclaration = t !== !1;
        return;
      }
      const n = this.object && typeof this.object.currentMaterial == "function" ? this.object.currentMaterial() : void 0;
      if (this.object && typeof this.object._finalize == "function" && this.object._finalize(!0), this.object = {
        name: e || "",
        fromDeclaration: t !== !1,
        geometry: {
          vertices: [],
          normals: [],
          colors: [],
          uvs: [],
          hasUVIndices: !1
        },
        materials: [],
        smooth: !0,
        startMaterial: function(s, i) {
          const o = this._finalize(!1);
          o && (o.inherited || o.groupCount <= 0) && this.materials.splice(o.index, 1);
          const c = {
            index: this.materials.length,
            name: s || "",
            mtllib: Array.isArray(i) && i.length > 0 ? i[i.length - 1] : "",
            smooth: o !== void 0 ? o.smooth : this.smooth,
            groupStart: o !== void 0 ? o.groupEnd : 0,
            groupEnd: -1,
            groupCount: -1,
            inherited: !1,
            clone: function(a) {
              const l = {
                index: typeof a == "number" ? a : this.index,
                name: this.name,
                mtllib: this.mtllib,
                smooth: this.smooth,
                groupStart: 0,
                groupEnd: -1,
                groupCount: -1,
                inherited: !1
              };
              return l.clone = this.clone.bind(l), l;
            }
          };
          return this.materials.push(c), c;
        },
        currentMaterial: function() {
          if (this.materials.length > 0)
            return this.materials[this.materials.length - 1];
        },
        _finalize: function(s) {
          const i = this.currentMaterial();
          if (i && i.groupEnd === -1 && (i.groupEnd = this.geometry.vertices.length / 3, i.groupCount = i.groupEnd - i.groupStart, i.inherited = !1), s && this.materials.length > 1)
            for (let o = this.materials.length - 1; o >= 0; o--)
              this.materials[o].groupCount <= 0 && this.materials.splice(o, 1);
          return s && this.materials.length === 0 && this.materials.push({
            name: "",
            smooth: this.smooth
          }), i;
        }
      }, n && n.name && typeof n.clone == "function") {
        const s = n.clone(0);
        s.inherited = !0, this.object.materials.push(s);
      }
      this.objects.push(this.object);
    },
    finalize: function() {
      this.object && typeof this.object._finalize == "function" && this.object._finalize(!0);
    },
    parseVertexIndex: function(e, t) {
      const n = parseInt(e, 10);
      return (n >= 0 ? n - 1 : n + t / 3) * 3;
    },
    parseNormalIndex: function(e, t) {
      const n = parseInt(e, 10);
      return (n >= 0 ? n - 1 : n + t / 3) * 3;
    },
    parseUVIndex: function(e, t) {
      const n = parseInt(e, 10);
      return (n >= 0 ? n - 1 : n + t / 2) * 2;
    },
    addVertex: function(e, t, n) {
      const s = this.vertices, i = this.object.geometry.vertices;
      i.push(s[e + 0], s[e + 1], s[e + 2]), i.push(s[t + 0], s[t + 1], s[t + 2]), i.push(s[n + 0], s[n + 1], s[n + 2]);
    },
    addVertexPoint: function(e) {
      const t = this.vertices;
      this.object.geometry.vertices.push(t[e + 0], t[e + 1], t[e + 2]);
    },
    addVertexLine: function(e) {
      const t = this.vertices;
      this.object.geometry.vertices.push(t[e + 0], t[e + 1], t[e + 2]);
    },
    addNormal: function(e, t, n) {
      const s = this.normals, i = this.object.geometry.normals;
      i.push(s[e + 0], s[e + 1], s[e + 2]), i.push(s[t + 0], s[t + 1], s[t + 2]), i.push(s[n + 0], s[n + 1], s[n + 2]);
    },
    addFaceNormal: function(e, t, n) {
      const s = this.vertices, i = this.object.geometry.normals;
      We.fromArray(s, e), xe.fromArray(s, t), qe.fromArray(s, n), O.subVectors(qe, xe), Ze.subVectors(We, xe), O.cross(Ze), O.normalize(), i.push(O.x, O.y, O.z), i.push(O.x, O.y, O.z), i.push(O.x, O.y, O.z);
    },
    addColor: function(e, t, n) {
      const s = this.colors, i = this.object.geometry.colors;
      s[e] !== void 0 && i.push(s[e + 0], s[e + 1], s[e + 2]), s[t] !== void 0 && i.push(s[t + 0], s[t + 1], s[t + 2]), s[n] !== void 0 && i.push(s[n + 0], s[n + 1], s[n + 2]);
    },
    addUV: function(e, t, n) {
      const s = this.uvs, i = this.object.geometry.uvs;
      i.push(s[e + 0], s[e + 1]), i.push(s[t + 0], s[t + 1]), i.push(s[n + 0], s[n + 1]);
    },
    addDefaultUV: function() {
      const e = this.object.geometry.uvs;
      e.push(0, 0), e.push(0, 0), e.push(0, 0);
    },
    addUVLine: function(e) {
      const t = this.uvs;
      this.object.geometry.uvs.push(t[e + 0], t[e + 1]);
    },
    addFace: function(e, t, n, s, i, o, c, a, l) {
      const u = this.vertices.length;
      let h = this.parseVertexIndex(e, u), d = this.parseVertexIndex(t, u), p = this.parseVertexIndex(n, u);
      if (this.addVertex(h, d, p), this.addColor(h, d, p), c !== void 0 && c !== "") {
        const y = this.normals.length;
        h = this.parseNormalIndex(c, y), d = this.parseNormalIndex(a, y), p = this.parseNormalIndex(l, y), this.addNormal(h, d, p);
      } else
        this.addFaceNormal(h, d, p);
      if (s !== void 0 && s !== "") {
        const y = this.uvs.length;
        h = this.parseUVIndex(s, y), d = this.parseUVIndex(i, y), p = this.parseUVIndex(o, y), this.addUV(h, d, p), this.object.geometry.hasUVIndices = !0;
      } else
        this.addDefaultUV();
    },
    addPointGeometry: function(e) {
      this.object.geometry.type = "Points";
      const t = this.vertices.length;
      for (let n = 0, s = e.length; n < s; n++) {
        const i = this.parseVertexIndex(e[n], t);
        this.addVertexPoint(i), this.addColor(i);
      }
    },
    addLineGeometry: function(e, t) {
      this.object.geometry.type = "Line";
      const n = this.vertices.length, s = this.uvs.length;
      for (let i = 0, o = e.length; i < o; i++)
        this.addVertexLine(this.parseVertexIndex(e[i], n));
      for (let i = 0, o = t.length; i < o; i++)
        this.addUVLine(this.parseUVIndex(t[i], s));
    }
  };
  return r.startObject("", !1), r;
}
class on extends De {
  constructor(e) {
    super(e), this.materials = null;
  }
  load(e, t, n, s) {
    const i = this, o = new fe(this.manager);
    o.setPath(this.path), o.setRequestHeader(this.requestHeader), o.setWithCredentials(this.withCredentials), o.load(e, function(c) {
      try {
        t(i.parse(c));
      } catch (a) {
        s ? s(a) : console.error(a), i.manager.itemError(e);
      }
    }, n, s);
  }
  setMaterials(e) {
    return this.materials = e, this;
  }
  parse(e) {
    const t = new nn();
    e.indexOf(`\r
`) !== -1 && (e = e.replace(/\r\n/g, `
`)), e.indexOf(`\\
`) !== -1 && (e = e.replace(/\\\n/g, ""));
    const n = e.split(`
`);
    let s = [];
    for (let c = 0, a = n.length; c < a; c++) {
      const l = n[c].trimStart();
      if (l.length === 0) continue;
      const u = l.charAt(0);
      if (u !== "#")
        if (u === "v") {
          const h = l.split(Ye);
          switch (h[0]) {
            case "v":
              t.vertices.push(
                parseFloat(h[1]),
                parseFloat(h[2]),
                parseFloat(h[3])
              ), h.length >= 7 ? (oe.setRGB(
                parseFloat(h[4]),
                parseFloat(h[5]),
                parseFloat(h[6]),
                F
              ), t.colors.push(oe.r, oe.g, oe.b)) : t.colors.push(void 0, void 0, void 0);
              break;
            case "vn":
              t.normals.push(
                parseFloat(h[1]),
                parseFloat(h[2]),
                parseFloat(h[3])
              );
              break;
            case "vt":
              t.uvs.push(
                parseFloat(h[1]),
                parseFloat(h[2])
              );
              break;
          }
        } else if (u === "f") {
          const d = l.slice(1).trim().split(Ye), p = [];
          for (let T = 0, f = d.length; T < f; T++) {
            const m = d[T];
            if (m.length > 0) {
              const g = m.split("/");
              p.push(g);
            }
          }
          const y = p[0];
          for (let T = 1, f = p.length - 1; T < f; T++) {
            const m = p[T], g = p[T + 1];
            t.addFace(
              y[0],
              m[0],
              g[0],
              y[1],
              m[1],
              g[1],
              y[2],
              m[2],
              g[2]
            );
          }
        } else if (u === "l") {
          const h = l.substring(1).trim().split(" ");
          let d = [];
          const p = [];
          if (l.indexOf("/") === -1)
            d = h;
          else
            for (let y = 0, T = h.length; y < T; y++) {
              const f = h[y].split("/");
              f[0] !== "" && d.push(f[0]), f[1] !== "" && p.push(f[1]);
            }
          t.addLineGeometry(d, p);
        } else if (u === "p") {
          const d = l.slice(1).trim().split(" ");
          t.addPointGeometry(d);
        } else if ((s = Js.exec(l)) !== null) {
          const h = (" " + s[0].slice(1).trim()).slice(1);
          t.startObject(h);
        } else if (tn.test(l))
          t.object.startMaterial(l.substring(7).trim(), t.materialLibraries);
        else if (en.test(l))
          t.materialLibraries.push(l.substring(7).trim());
        else if (sn.test(l))
          console.warn('THREE.OBJLoader: Rendering identifier "usemap" not supported. Textures must be defined in MTL files.');
        else if (u === "s") {
          if (s = l.split(" "), s.length > 1) {
            const d = s[1].trim().toLowerCase();
            t.object.smooth = d !== "0" && d !== "off";
          } else
            t.object.smooth = !0;
          const h = t.object.currentMaterial();
          h && (h.smooth = t.object.smooth);
        } else {
          if (l === "\0") continue;
          console.warn('THREE.OBJLoader: Unexpected line: "' + l + '"');
        }
    }
    t.finalize();
    const i = new ce();
    if (i.materialLibraries = [].concat(t.materialLibraries), !(t.objects.length === 1 && t.objects[0].geometry.vertices.length === 0) === !0)
      for (let c = 0, a = t.objects.length; c < a; c++) {
        const l = t.objects[c], u = l.geometry, h = l.materials, d = u.type === "Line", p = u.type === "Points";
        let y = !1;
        if (u.vertices.length === 0) continue;
        const T = new ue();
        T.setAttribute("position", new G(u.vertices, 3)), u.normals.length > 0 && T.setAttribute("normal", new G(u.normals, 3)), u.colors.length > 0 && (y = !0, T.setAttribute("color", new G(u.colors, 3))), u.hasUVIndices === !0 && T.setAttribute("uv", new G(u.uvs, 2));
        const f = [];
        for (let g = 0, w = h.length; g < w; g++) {
          const _ = h[g], M = _.name + "_" + _.smooth + "_" + y;
          let A = t.materials[M];
          if (this.materials !== null) {
            if (A = this.materials.create(_.name), d && A && !(A instanceof re)) {
              const b = new re();
              se.prototype.copy.call(b, A), b.color.copy(A.color), A = b;
            } else if (p && A && !(A instanceof ee)) {
              const b = new ee({ size: 10, sizeAttenuation: !1 });
              se.prototype.copy.call(b, A), b.color.copy(A.color), b.map = A.map, A = b;
            }
          }
          A === void 0 && (d ? A = new re() : p ? A = new ee({ size: 1, sizeAttenuation: !1 }) : A = new ct(), A.name = _.name, A.flatShading = !_.smooth, A.vertexColors = y, t.materials[M] = A), f.push(A);
        }
        let m;
        if (f.length > 1) {
          for (let g = 0, w = h.length; g < w; g++) {
            const _ = h[g];
            T.addGroup(_.groupStart, _.groupCount, g);
          }
          d ? m = new Le(T, f) : p ? m = new ae(T, f) : m = new de(T, f);
        } else
          d ? m = new Le(T, f[0]) : p ? m = new ae(T, f[0]) : m = new de(T, f[0]);
        m.name = l.name, i.add(m);
      }
    else if (t.vertices.length > 0) {
      const c = new ee({ size: 1, sizeAttenuation: !1 }), a = new ue();
      a.setAttribute("position", new G(t.vertices, 3)), t.colors.length > 0 && t.colors[0] !== void 0 && (a.setAttribute("color", new G(t.colors, 3)), c.vertexColors = !0);
      const l = new ae(a, c);
      i.add(l);
    }
    return i;
  }
}
class rn extends De {
  constructor(e) {
    super(e);
  }
  /**
   * Loads and parses a MTL asset from a URL.
   *
   * @param {String} url - URL to the MTL file.
   * @param {Function} [onLoad] - Callback invoked with the loaded object.
   * @param {Function} [onProgress] - Callback for download progress.
   * @param {Function} [onError] - Callback for download errors.
   *
   * @see setPath setResourcePath
   *
   * @note In order for relative texture references to resolve correctly
   * you must call setResourcePath() explicitly prior to load.
   */
  load(e, t, n, s) {
    const i = this, o = this.path === "" ? q.extractUrlBase(e) : this.path, c = new fe(this.manager);
    c.setPath(this.path), c.setRequestHeader(this.requestHeader), c.setWithCredentials(this.withCredentials), c.load(e, function(a) {
      try {
        t(i.parse(a, o));
      } catch (l) {
        s ? s(l) : console.error(l), i.manager.itemError(e);
      }
    }, n, s);
  }
  setMaterialOptions(e) {
    return this.materialOptions = e, this;
  }
  /**
   * Parses a MTL file.
   *
   * @param {String} text - Content of MTL file
   * @return {MaterialCreator}
   *
   * @see setPath setResourcePath
   *
   * @note In order for relative texture references to resolve correctly
   * you must call setResourcePath() explicitly prior to parse.
   */
  parse(e, t) {
    const n = e.split(`
`);
    let s = {};
    const i = /\s+/, o = {};
    for (let a = 0; a < n.length; a++) {
      let l = n[a];
      if (l = l.trim(), l.length === 0 || l.charAt(0) === "#")
        continue;
      const u = l.indexOf(" ");
      let h = u >= 0 ? l.substring(0, u) : l;
      h = h.toLowerCase();
      let d = u >= 0 ? l.substring(u + 1) : "";
      if (d = d.trim(), h === "newmtl")
        s = { name: d }, o[d] = s;
      else if (h === "ka" || h === "kd" || h === "ks" || h === "ke") {
        const p = d.split(i, 3);
        s[h] = [parseFloat(p[0]), parseFloat(p[1]), parseFloat(p[2])];
      } else
        s[h] = d;
    }
    const c = new an(this.resourcePath || t, this.materialOptions);
    return c.setCrossOrigin(this.crossOrigin), c.setManager(this.manager), c.setMaterials(o), c;
  }
}
class an {
  constructor(e = "", t = {}) {
    this.baseUrl = e, this.options = t, this.materialsInfo = {}, this.materials = {}, this.materialsArray = [], this.nameLookup = {}, this.crossOrigin = "anonymous", this.side = this.options.side !== void 0 ? this.options.side : at, this.wrap = this.options.wrap !== void 0 ? this.options.wrap : he;
  }
  setCrossOrigin(e) {
    return this.crossOrigin = e, this;
  }
  setManager(e) {
    this.manager = e;
  }
  setMaterials(e) {
    this.materialsInfo = this.convert(e), this.materials = {}, this.materialsArray = [], this.nameLookup = {};
  }
  convert(e) {
    if (!this.options) return e;
    const t = {};
    for (const n in e) {
      const s = e[n], i = {};
      t[n] = i;
      for (const o in s) {
        let c = !0, a = s[o];
        const l = o.toLowerCase();
        switch (l) {
          case "kd":
          case "ka":
          case "ks":
            this.options && this.options.normalizeRGB && (a = [a[0] / 255, a[1] / 255, a[2] / 255]), this.options && this.options.ignoreZeroRGBs && a[0] === 0 && a[1] === 0 && a[2] === 0 && (c = !1);
            break;
        }
        c && (i[l] = a);
      }
    }
    return t;
  }
  preload() {
    for (const e in this.materialsInfo)
      this.create(e);
  }
  getIndex(e) {
    return this.nameLookup[e];
  }
  getAsArray() {
    let e = 0;
    for (const t in this.materialsInfo)
      this.materialsArray[e] = this.create(t), this.nameLookup[t] = e, e++;
    return this.materialsArray;
  }
  create(e) {
    return this.materials[e] === void 0 && this.createMaterial_(e), this.materials[e];
  }
  createMaterial_(e) {
    const t = this, n = this.materialsInfo[e], s = {
      name: e,
      side: this.side
    };
    function i(c, a) {
      return typeof a != "string" || a === "" ? "" : /^https?:\/\//i.test(a) ? a : c + a;
    }
    function o(c, a) {
      if (s[c]) return;
      const l = t.getTextureParams(a, s), u = t.loadTexture(i(t.baseUrl, l.url));
      u.repeat.copy(l.scale), u.offset.copy(l.offset), u.wrapS = t.wrap, u.wrapT = t.wrap, (c === "map" || c === "emissiveMap") && (u.colorSpace = F), s[c] = u;
    }
    for (const c in n) {
      const a = n[c];
      let l;
      if (a !== "")
        switch (c.toLowerCase()) {
          // Ns is material specular exponent
          case "kd":
            s.color = ne.toWorkingColorSpace(new v().fromArray(a), F);
            break;
          case "ks":
            s.specular = ne.toWorkingColorSpace(new v().fromArray(a), F);
            break;
          case "ke":
            s.emissive = ne.toWorkingColorSpace(new v().fromArray(a), F);
            break;
          case "map_kd":
            o("map", a);
            break;
          case "map_ks":
            o("specularMap", a);
            break;
          case "map_ke":
            o("emissiveMap", a);
            break;
          case "norm":
            o("normalMap", a);
            break;
          case "map_bump":
          case "bump":
            o("bumpMap", a);
            break;
          case "map_d":
            o("alphaMap", a), s.transparent = !0;
            break;
          case "ns":
            s.shininess = parseFloat(a);
            break;
          case "d":
            l = parseFloat(a), l < 1 && (s.opacity = l, s.transparent = !0);
            break;
          case "tr":
            l = parseFloat(a), this.options && this.options.invertTrProperty && (l = 1 - l), l > 0 && (s.opacity = 1 - l, s.transparent = !0);
            break;
        }
    }
    return this.materials[e] = new ct(s), this.materials[e];
  }
  getTextureParams(e, t) {
    const n = {
      scale: new C(1, 1),
      offset: new C(0, 0)
    }, s = e.split(/\s+/);
    let i;
    return i = s.indexOf("-bm"), i >= 0 && (t.bumpScale = parseFloat(s[i + 1]), s.splice(i, 2)), i = s.indexOf("-s"), i >= 0 && (n.scale.set(parseFloat(s[i + 1]), parseFloat(s[i + 2])), s.splice(i, 4)), i = s.indexOf("-o"), i >= 0 && (n.offset.set(parseFloat(s[i + 1]), parseFloat(s[i + 2])), s.splice(i, 4)), n.url = s.join(" ").trim(), n;
  }
  loadTexture(e, t, n, s, i) {
    const o = this.manager !== void 0 ? this.manager : Zt;
    let c = o.getHandler(e);
    c === null && (c = new st(o)), c.setCrossOrigin && c.setCrossOrigin(this.crossOrigin);
    const a = c.load(e, n, s, i);
    return t !== void 0 && (a.mapping = t), a;
  }
}
function cn(r) {
  const e = r.split(/[?#]/)[0].toLowerCase();
  if (e.endsWith(".glb")) return "glb";
  if (e.endsWith(".gltf")) return "gltf";
  if (e.endsWith(".obj")) return "obj";
}
async function ln(r, e, t = !1) {
  const n = e ?? cn(r);
  if (!n)
    throw new Error(`Could not determine model format for "${r}". Use .glb, .gltf or .obj.`);
  const s = n === "obj" ? await un(r, t) : await hn(r);
  return { object: s, partNames: dt(s) };
}
async function hn(r) {
  return (await new As().loadAsync(r)).scene;
}
async function un(r, e = !1) {
  const t = new on();
  if (!e) {
    const n = r.replace(/\.obj($|[?#])/i, ".mtl$1");
    if (n !== r)
      try {
        const s = await new rn().loadAsync(n);
        s.preload(), t.setMaterials(s);
      } catch {
      }
  }
  return t.loadAsync(r);
}
function dt(r) {
  const e = /* @__PURE__ */ new Set();
  return r.traverse((t) => {
    t.name && e.add(t.name);
    const n = t;
    if (n.isMesh) {
      const s = Array.isArray(n.material) ? n.material : [n.material];
      for (const i of s)
        i?.name && e.add(i.name);
    }
  }), [...e];
}
function dn(r, e = 2) {
  const t = new x.Box3().setFromObject(r), n = t.getSize(new x.Vector3()), s = t.getCenter(new x.Vector3()), i = Math.max(n.x, n.y, n.z) || 1, o = e / i;
  r.position.sub(s.multiplyScalar(o)), r.scale.multiplyScalar(o);
  const c = new x.Box3().setFromObject(r).getBoundingSphere(new x.Sphere());
  return { radius: c.radius, center: c.center };
}
function fn(r, e, t = 1.25) {
  const n = e * Math.PI / 180;
  return r / Math.sin(n / 2) * t;
}
const Ee = Math.PI / 180;
function pn(r, e, t) {
  const n = (e === "z" ? -90 : 0) + t[0];
  r.rotation.set(n * Ee, t[1] * Ee, t[2] * Ee);
}
function mn(r, e) {
  const t = dt(r);
  return Jt(t, e).map((s) => {
    const i = gn(r, s.name);
    return {
      config: s,
      targets: i,
      meshes: An(i)
    };
  });
}
function gn(r, e) {
  const t = [];
  return r.traverse((n) => {
    const s = n;
    if (s.isMesh) {
      if (s.name === e) {
        t.push({ mesh: s });
        return;
      }
      t.push(..._n(s, e));
    }
  }), t;
}
function _n(r, e) {
  const t = Array.isArray(r.material) ? r.material : [r.material], n = [];
  return t.forEach((s, i) => {
    s?.name === e && n.push({ mesh: r, materialName: e, materialIndex: i });
  }), n;
}
function An(r) {
  return [...new Set(r.map((e) => e.mesh))];
}
function yn(r) {
  const e = Mn(r);
  if (!e.length) return;
  const t = Rn(e), n = new x.Box3();
  for (const a of e) n.expandByPoint(a);
  if (n.isEmpty()) return;
  const s = new x.Vector3();
  n.getCenter(s);
  const i = mt(t, s);
  let o, c;
  return i ? { width: o, height: c } = Ln(t, s, i) : { width: o, height: c } = In(n), {
    width: o,
    height: c,
    aspectRatio: c > 0 ? o / c : 1,
    meshCount: r.meshes.length
  };
}
function Qe(r, e) {
  const t = new x.Color(e);
  Ne(r, (n) => {
    n.color.copy(t), n.needsUpdate = !0;
  });
}
function Tn(r, e) {
  Ne(r, (t) => {
    t.roughness = e, t.needsUpdate = !0;
  });
}
function $e(r, e, t = {}) {
  e.colorSpace = x.SRGBColorSpace;
  const n = xn(r);
  r.generatedUVs === void 0 && (r.generatedUVs = n), Ne(r, (s) => {
    s.map = e, s.color.setRGB(1, 1, 1), t.transparent !== void 0 && (s.transparent = t.transparent), s.needsUpdate = !0;
  }), e.flipY = r.generatedUVs ?? !1, wn(e, r.config.artwork), e.needsUpdate = !0;
}
const bn = Math.PI / 180;
function wn(r, e) {
  r.center.set(0.5, 0.5);
  const t = e.scale || 1;
  r.repeat.set((e.flipU ? -1 : 1) / t, (e.flipV ? -1 : 1) / t), r.rotation = e.rotation * bn, r.offset.set(e.offset[0], e.offset[1]), r.wrapS = x.ClampToEdgeWrapping, r.wrapT = x.ClampToEdgeWrapping;
}
const U = { x: 0, y: 1, z: 2 }, V = ["x", "y", "z"];
function xn(r) {
  let e = !1;
  for (const [t, n] of ft(r.targets)) {
    const s = t.geometry, i = s.getAttribute("position");
    if (!i) continue;
    const o = pt(s, n), c = s.getAttribute("uv");
    if (c && Cn(c, o)) continue;
    const a = En(i, o);
    if (!a || a.isEmpty()) continue;
    const l = new x.Vector3();
    a.getCenter(l);
    const u = mt(i, l, o);
    u ? Sn(s, i, l, u, o) : Pn(s, i, a), e = !0;
  }
  return e;
}
function ft(r) {
  const e = /* @__PURE__ */ new Map();
  for (const t of r)
    e.set(t.mesh, [...e.get(t.mesh) ?? [], t]);
  return e;
}
function pt(r, e) {
  if (e.some((o) => o.materialIndex === void 0)) return;
  const t = new Set(e.map((o) => o.materialIndex)), n = r.groups.filter((o) => t.has(o.materialIndex ?? 0));
  if (!n.length) return t.has(0) ? void 0 : [];
  const s = /* @__PURE__ */ new Set(), i = r.index;
  for (const o of n) {
    const c = o.start + o.count;
    for (let a = o.start; a < c; a++)
      s.add(i ? i.getX(a) : a);
  }
  return [...s];
}
function En(r, e) {
  const t = new x.Box3(), n = new x.Vector3();
  let s = 0;
  return $(r, e, (i) => {
    n.fromBufferAttribute(r, i), t.expandByPoint(n), s++;
  }), s ? t : void 0;
}
function Mn(r) {
  const e = [];
  for (const [t, n] of ft(r.targets)) {
    const s = t.geometry, i = s.getAttribute("position");
    if (!i) continue;
    const o = pt(s, n);
    $(i, o, (c) => {
      e.push(new x.Vector3().fromBufferAttribute(i, c));
    });
  }
  return e;
}
function Rn(r) {
  const e = new Float32Array(r.length * 3);
  return r.forEach((t, n) => {
    e[n * 3] = t.x, e[n * 3 + 1] = t.y, e[n * 3 + 2] = t.z;
  }), new x.BufferAttribute(e, 3);
}
function $(r, e, t) {
  if (e) {
    for (const n of e) t(n);
    return;
  }
  for (let n = 0; n < r.count; n++) t(n);
}
function mt(r, e, t) {
  let n = null, s = 1 / 0;
  for (const i of V) {
    const [o, c] = V.filter((f) => f !== i), a = e[o], l = e[c];
    let u = 0, h = 0, d = 0;
    if ($(r, t, (f) => {
      const m = r.getComponent(f, U[o]) - a, g = r.getComponent(f, U[c]) - l, w = Math.hypot(m, g);
      u += w, h += w * w, d++;
    }), !d) continue;
    const p = u / d;
    if (p < 1e-6) continue;
    const y = Math.max(h / d - p * p, 0), T = Math.sqrt(y) / p;
    T < s && (s = T, n = i);
  }
  return s < 0.2 ? n : null;
}
function Sn(r, e, t, n, s) {
  const [i, o] = V.filter((b) => b !== n), c = t[i], a = t[o], l = U[n], u = U[i], h = U[o];
  let d = 0, p = 0;
  $(e, s, (b) => {
    const R = Math.atan2(e.getComponent(b, h) - a, e.getComponent(b, u) - c);
    d += Math.sin(R), p += Math.cos(R);
  });
  const y = Math.atan2(d, p), T = new Float32Array(e.count);
  let f = 1 / 0, m = -1 / 0, g = 1 / 0, w = -1 / 0;
  $(e, s, (b) => {
    const R = Math.atan2(e.getComponent(b, h) - a, e.getComponent(b, u) - c), I = Math.atan2(Math.sin(R - y), Math.cos(R - y));
    T[b] = I, I < f && (f = I), I > m && (m = I);
    const j = e.getComponent(b, l);
    j < g && (g = j), j > w && (w = j);
  });
  const _ = m - f || 1, M = w - g || 1, A = new Float32Array(e.count * 2);
  for (let b = 0; b < e.count; b++)
    A[b * 2] = (T[b] - f) / _, A[b * 2 + 1] = (e.getComponent(b, l) - g) / M;
  r.setAttribute("uv", new x.BufferAttribute(A, 2));
}
function Ln(r, e, t) {
  const [n, s] = V.filter((w) => w !== t), i = e[n], o = e[s], c = U[t], a = U[n], l = U[s];
  let u = 0, h = 0, d = 0;
  for (let w = 0; w < r.count; w++) {
    const _ = r.getComponent(w, a) - i, M = r.getComponent(w, l) - o, A = Math.atan2(M, _);
    u += Math.sin(A), h += Math.cos(A), d += Math.hypot(_, M);
  }
  const p = Math.atan2(u, h), y = d / r.count;
  let T = 1 / 0, f = -1 / 0, m = 1 / 0, g = -1 / 0;
  for (let w = 0; w < r.count; w++) {
    const _ = Math.atan2(r.getComponent(w, l) - o, r.getComponent(w, a) - i), M = Math.atan2(Math.sin(_ - p), Math.cos(_ - p));
    M < T && (T = M), M > f && (f = M);
    const A = r.getComponent(w, c);
    A < m && (m = A), A > g && (g = A);
  }
  return {
    width: Math.max((f - T) * y, 0),
    height: Math.max(g - m, 0)
  };
}
function In(r) {
  const e = new x.Vector3();
  r.getSize(e);
  const t = V.reduce((i, o) => e[o] < e[i] ? o : i, "x"), [n, s] = V.filter((i) => i !== t);
  return { width: e[n], height: e[s] };
}
function Pn(r, e, t) {
  const n = new x.Vector3();
  t.getSize(n);
  const s = V.reduce((u, h) => n[h] < n[u] ? h : u, "x"), [i, o] = V.filter((u) => u !== s), c = n[i] || 1, a = n[o] || 1, l = new Float32Array(e.count * 2);
  for (let u = 0; u < e.count; u++) {
    const h = e.getComponent(u, U[i]), d = e.getComponent(u, U[o]);
    l[u * 2] = (h - t.min[i]) / c, l[u * 2 + 1] = (d - t.min[o]) / a;
  }
  r.setAttribute("uv", new x.BufferAttribute(l, 2));
}
function Cn(r, e) {
  let t = 1 / 0, n = 1 / 0, s = -1 / 0, i = -1 / 0, o = 0;
  if ($(r, e, (u) => {
    const h = r.getX(u), d = r.getY(u);
    h < t && (t = h), h > s && (s = h), d < n && (n = d), d > i && (i = d), o++;
  }), !o) return !1;
  const c = 1e-3, a = t >= -c && n >= -c && s <= 1 + c && i <= 1 + c, l = s - t > c && i - n > c;
  return a && l;
}
function Dn(r, e, t, n) {
  const s = Array.isArray(r.material), o = (s ? r.material : [r.material]).map((c, a) => {
    if (n !== void 0 && a !== n || t && c.name !== t) return c;
    const l = On(c);
    return e(l), l;
  });
  r.material = s ? o : o[0];
}
function Ne(r, e) {
  for (const t of r.targets)
    Dn(t.mesh, e, t.materialName, t.materialIndex);
}
function On(r) {
  if (r instanceof x.MeshStandardMaterial) return r;
  const e = new x.MeshStandardMaterial();
  e.name = r.name;
  const t = r;
  return t.color && e.color.copy(t.color), t.map && (e.map = t.map), e;
}
class Nn extends ue {
  constructor(e = new de(), t = new S(), n = new Qt(), s = new S(1, 1, 1)) {
    super();
    const i = [], o = [], c = [], a = new S(), l = new $t().getNormalMatrix(e.matrixWorld), u = new Q();
    u.makeRotationFromEuler(n), u.setPosition(t);
    const h = new Q();
    h.copy(u).invert(), d(), this.setAttribute("position", new G(i, 3)), this.setAttribute("uv", new G(c, 2)), o.length > 0 && this.setAttribute("normal", new G(o, 3));
    function d() {
      let f = [];
      const m = new S(), g = new S(), w = e.geometry, _ = w.attributes.position, M = w.attributes.normal;
      if (w.index !== null) {
        const A = w.index;
        for (let b = 0; b < A.count; b++)
          m.fromBufferAttribute(_, A.getX(b)), M ? (g.fromBufferAttribute(M, A.getX(b)), p(f, m, g)) : p(f, m);
      } else {
        if (_ === void 0) return;
        for (let A = 0; A < _.count; A++)
          m.fromBufferAttribute(_, A), M ? (g.fromBufferAttribute(M, A), p(f, m, g)) : p(f, m);
      }
      f = y(f, a.set(1, 0, 0)), f = y(f, a.set(-1, 0, 0)), f = y(f, a.set(0, 1, 0)), f = y(f, a.set(0, -1, 0)), f = y(f, a.set(0, 0, 1)), f = y(f, a.set(0, 0, -1));
      for (let A = 0; A < f.length; A++) {
        const b = f[A];
        c.push(
          0.5 + b.position.x / s.x,
          0.5 + b.position.y / s.y
        ), b.position.applyMatrix4(u), i.push(b.position.x, b.position.y, b.position.z), b.normal !== null && o.push(b.normal.x, b.normal.y, b.normal.z);
      }
    }
    function p(f, m, g = null) {
      m.applyMatrix4(e.matrixWorld), m.applyMatrix4(h), g ? (g.applyNormalMatrix(l), f.push(new Me(m.clone(), g.clone()))) : f.push(new Me(m.clone()));
    }
    function y(f, m) {
      const g = [], w = 0.5 * Math.abs(s.dot(m));
      for (let _ = 0; _ < f.length; _ += 3) {
        let M = 0, A, b, R, I;
        const j = f[_ + 0].position.dot(m) - w, _t = f[_ + 1].position.dot(m) - w, At = f[_ + 2].position.dot(m) - w, pe = j > 0, me = _t > 0, ge = At > 0;
        switch (M = (pe ? 1 : 0) + (me ? 1 : 0) + (ge ? 1 : 0), M) {
          case 0: {
            g.push(f[_]), g.push(f[_ + 1]), g.push(f[_ + 2]);
            break;
          }
          case 1: {
            if (pe && (A = f[_ + 1], b = f[_ + 2], R = T(f[_], A, m, w), I = T(f[_], b, m, w)), me) {
              A = f[_], b = f[_ + 2], R = T(f[_ + 1], A, m, w), I = T(f[_ + 1], b, m, w), g.push(R), g.push(b.clone()), g.push(A.clone()), g.push(b.clone()), g.push(R.clone()), g.push(I);
              break;
            }
            ge && (A = f[_], b = f[_ + 1], R = T(f[_ + 2], A, m, w), I = T(f[_ + 2], b, m, w)), g.push(A.clone()), g.push(b.clone()), g.push(R), g.push(I), g.push(R.clone()), g.push(b.clone());
            break;
          }
          case 2: {
            pe || (A = f[_].clone(), b = T(A, f[_ + 1], m, w), R = T(A, f[_ + 2], m, w), g.push(A), g.push(b), g.push(R)), me || (A = f[_ + 1].clone(), b = T(A, f[_ + 2], m, w), R = T(A, f[_], m, w), g.push(A), g.push(b), g.push(R)), ge || (A = f[_ + 2].clone(), b = T(A, f[_], m, w), R = T(A, f[_ + 1], m, w), g.push(A), g.push(b), g.push(R));
            break;
          }
        }
      }
      return g;
    }
    function T(f, m, g, w) {
      const _ = f.position.dot(g) - w, M = m.position.dot(g) - w, A = _ / (_ - M), b = new S(
        f.position.x + A * (m.position.x - f.position.x),
        f.position.y + A * (m.position.y - f.position.y),
        f.position.z + A * (m.position.z - f.position.z)
      );
      let R = null;
      return f.normal !== null && m.normal !== null && (R = new S(
        f.normal.x + A * (m.normal.x - f.normal.x),
        f.normal.y + A * (m.normal.y - f.normal.y),
        f.normal.z + A * (m.normal.z - f.normal.z)
      )), new Me(b, R);
    }
  }
}
class Me {
  constructor(e, t = null) {
    this.position = e, this.normal = t;
  }
  clone() {
    const e = this.position.clone(), t = this.normal !== null ? this.normal.clone() : null;
    return new this.constructor(e, t);
  }
}
class kn {
  constructor(e) {
    this.parent = e;
  }
  decals = /* @__PURE__ */ new Map();
  /**
   * Create or replace a named decal on `target` using `texture` at `placement`.
   * Returns the decal mesh so callers can track or transform it.
   */
  place(e, t, n, s) {
    this.remove(e);
    const i = new x.Euler(), o = new x.Vector3(0, 0, 1), c = new x.Quaternion().setFromUnitVectors(o, s.normal.clone().normalize());
    i.setFromQuaternion(c), s.rotation && (i.z = s.rotation);
    const a = new Nn(t, s.position, i, s.size);
    n.colorSpace = x.SRGBColorSpace;
    const l = new x.MeshStandardMaterial({
      map: n,
      transparent: !0,
      depthTest: !0,
      depthWrite: !1,
      polygonOffset: !0,
      polygonOffsetFactor: -4
    }), u = new x.Mesh(a, l);
    return u.name = `pa-decal-${e}`, this.parent.add(u), this.decals.set(e, u), u;
  }
  /** Remove and dispose a named decal, if present. */
  remove(e) {
    const t = this.decals.get(e);
    t && (this.parent.remove(t), t.geometry.dispose(), jn(t.material), this.decals.delete(e));
  }
  /** Remove and dispose every decal. */
  clear() {
    for (const e of [...this.decals.keys()]) this.remove(e);
  }
}
function vn(r, e, t, n) {
  r.setFromCamera(t, e);
  const [s] = r.intersectObjects(n, !0);
  if (!s || !s.face) return;
  const i = s.object, o = s.face.normal.clone();
  return o.transformDirection(i.matrixWorld).normalize(), { mesh: i, point: s.point.clone(), normal: o };
}
function jn(r) {
  const e = Array.isArray(r) ? r : [r];
  for (const t of e) t.dispose();
}
const k = {
  font: "sans-serif",
  fontSize: 160,
  fontWeight: "normal",
  fontStyle: "normal",
  color: "#000000",
  align: "center",
  lineHeight: 1.2,
  padding: 48,
  canvasWidth: 1024,
  canvasHeight: 1024
};
function gt(r) {
  const e = r.fontStyle ?? k.fontStyle, t = r.fontWeight ?? k.fontWeight, n = r.fontSize ?? k.fontSize, s = r.font ?? k.font;
  return `${e} ${t} ${n}px ${s}`;
}
async function Fn(r) {
  const e = document.fonts;
  if (e?.load)
    try {
      await e.load(gt(r), r.text || "Ag");
    } catch {
    }
}
async function Un(r) {
  await Fn(r);
  const e = r.backgroundImage ? await Ie(r.backgroundImage) : void 0, t = r.canvasWidth ?? k.canvasWidth, n = r.canvasHeight ?? k.canvasHeight, s = r.padding ?? k.padding, i = document.createElement("canvas");
  i.width = t, i.height = n;
  const o = i.getContext("2d");
  if (!o) throw new Error("Unable to acquire 2D canvas context for text rendering.");
  r.background && (o.fillStyle = r.background, o.fillRect(0, 0, t, n)), e && Hn(o, e, t, n, r.backgroundFit ?? "cover"), o.fillStyle = r.color ?? k.color, o.font = gt(r);
  const c = r.align ?? k.align;
  o.textAlign = c, o.textBaseline = "middle";
  const a = (r.text ?? "").split(`
`), l = (r.fontSize ?? k.fontSize) * (r.lineHeight ?? k.lineHeight), u = r.x ?? (c === "left" ? s : c === "right" ? t - s : t / 2), h = r.y ?? n / 2 - (a.length - 1) * l / 2;
  return a.forEach((d, p) => {
    o.fillText(d, u, h + p * l);
  }), i;
}
function Hn(r, e, t, n, s) {
  if (s === "fill") {
    r.drawImage(e, 0, 0, t, n);
    return;
  }
  const i = s === "cover" ? Math.max(t / e.width, n / e.height) : Math.min(t / e.width, n / e.height), o = e.width * i, c = e.height * i, a = (t - o) / 2, l = (n - c) / 2;
  r.drawImage(e, a, l, o, c);
}
class Bn {
  id = "3d";
  scene;
  projector;
  raycaster = new x.Raycaster();
  slots = [];
  config;
  events;
  placingArtwork;
  onPointerDown;
  async mount(e, t) {
    this.config = e, this.events = t.events;
    const n = new ps(t.container, e);
    n.scene.add(ms(e.lights, n.camera)), n.setInteractionHandler(() => t.events.emit("interact", { kind: "3d:orbit" })), this.scene = n, this.projector = new kn(n.modelRoot), await this.loadInto(e), n.start(), this.onPointerDown = (s) => this.handlePointerDown(s), n.renderer.domElement.addEventListener("pointerdown", this.onPointerDown);
  }
  async loadInto(e) {
    if (!this.scene) return;
    const { object: t } = await ln(e.model.url, e.model.format, e.model.noMtl);
    pn(t, e.model.upAxis, e.model.rotation);
    const { radius: n } = dn(t);
    this.scene.modelRoot.clear(), this.scene.modelRoot.add(t), this.slots = mn(t, e.slots);
    for (const o of this.slots)
      o.config.role === "color" && o.config.defaultColor && Qe(o, o.config.defaultColor), o.config.roughness !== void 0 && Tn(o, o.config.roughness);
    const s = new x.Vector3(...e.camera.position).length(), i = s > 0 ? s : fn(n, e.camera.fov);
    this.scene.frame(n, i);
  }
  /** List the slots discovered/configured on the current model. */
  getSlots() {
    return this.slots.map((e) => ({
      name: e.config.name,
      role: e.config.role,
      label: e.config.label,
      meshCount: e.meshes.length
    }));
  }
  /** Current camera position and orbit target, ready to paste back into config. */
  getCameraState() {
    if (!this.scene) return;
    const e = this.scene.camera.position, t = this.scene.controls.target;
    return {
      position: [+e.x.toFixed(4), +e.y.toFixed(4), +e.z.toFixed(4)],
      target: [+t.x.toFixed(4), +t.y.toFixed(4), +t.z.toFixed(4)],
      fov: this.config?.camera.fov ?? 45
    };
  }
  /** Approximate physical dimensions of the geometry controlled by a slot. */
  getSlotMetrics(e) {
    const t = this.slots.find((n) => n.config.name === e);
    if (!t) throw new Error(`No slot named "${e}".`);
    return yn(t);
  }
  /** Set a flat color on a named slot. */
  setColor(e, t) {
    const n = this.slots.find((s) => s.config.name === e);
    if (!n) throw new Error(`No slot named "${e}".`);
    Qe(n, t), this.events?.emit("change", { kind: "color", detail: { slotName: e, color: t } });
  }
  /**
   * Apply customer artwork to a named slot's material (UV path). Use this when the
   * slot already has usable UVs (typical for prepared models).
   */
  async setArtwork(e, t) {
    const n = this.slots.find((o) => o.config.name === e);
    if (!n) throw new Error(`No slot named "${e}".`);
    const s = await Ie(t), i = new x.Texture(s);
    i.needsUpdate = !0, $e(n, i), this.events?.emit("change", { kind: "artwork", detail: { slotName: e } });
  }
  /**
   * Render customer text onto a named slot's surface (UV path). The text is drawn to a
   * canvas and applied as artwork, so it inherits the slot's UV/curved-surface wrapping.
   * Omit `background` (and `backgroundImage`) to composite the text over the slot's base
   * color.
   */
  async setText(e, t) {
    const n = this.slots.find((c) => c.config.name === e);
    if (!n) throw new Error(`No slot named "${e}".`);
    const s = await Un(t), i = new x.CanvasTexture(s);
    i.needsUpdate = !0;
    const o = !!(t.background || t.backgroundImage);
    $e(n, i, { transparent: !o }), this.events?.emit("change", { kind: "artwork", detail: { slotName: e } });
  }
  /**
   * Enter click-to-place mode: the next click on the model stamps this artwork as a
   * decal at the clicked point (no-UV path, for unprepared/customer models).
   */
  async beginPlaceArtwork(e, t = 0.4) {
    const n = await Ie(e), s = new x.Texture(n);
    s.needsUpdate = !0, this.placingArtwork = { texture: s, size: t, counter: 0 }, this.events?.emit("interact", { kind: "3d:place-armed" });
  }
  handlePointerDown(e) {
    if (!this.placingArtwork || !this.scene || !this.projector) return;
    const t = this.scene.toNdc(e), n = this.scene.modelRoot.children, s = vn(this.raycaster, this.scene.camera, t, n);
    if (!s) return;
    const c = new x.Box3().setFromObject(this.scene.modelRoot).getSize(new x.Vector3()).length() * this.placingArtwork.size, a = new x.Vector3(c, c, c), l = `artwork-${this.placingArtwork.counter++}`;
    this.projector.place(l, s.mesh, this.placingArtwork.texture, {
      position: s.point,
      normal: s.normal,
      size: a
    }), this.events?.emit("change", { kind: "decal", detail: { id: l } });
  }
  /** Cancel any pending click-to-place arming. */
  cancelPlaceArtwork() {
    this.placingArtwork = void 0;
  }
  async update(e) {
    e.model.url !== this.config?.model.url && await this.loadInto(e), this.config = e;
  }
  resize() {
    this.scene?.resize();
  }
  dispose() {
    this.onPointerDown && this.scene && this.scene.renderer.domElement.removeEventListener("pointerdown", this.onPointerDown), this.projector?.clear(), this.scene?.dispose(), this.scene = void 0, this.slots = [];
  }
}
function Kn() {
  return new Bn();
}
export {
  kn as DecalProjector,
  ps as SceneController,
  Bn as ThreeViewMode,
  Qe as applySlotColor,
  $e as applySlotTexture,
  mn as bindSlots,
  ms as buildLights,
  dt as collectPartNames,
  Kn as createThreeMode,
  fn as fitDistance,
  cn as inferFormat,
  ln as loadModel,
  dn as normalizeModel,
  vn as pickSurface,
  Un as renderTextToCanvas
};
//# sourceMappingURL=index.js.map
